import React, { useEffect, useRef, useState } from "react";
import PatientListService from "../../../services/PatientListService";
import WrapperCard from "../../../component-lib/Atoms/card/EventEHRWrapperCard";
import { FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import DatePicker from "../../../component-lib/Atoms/DatePicker/DatePicker";
import EventEHRTimePicker from "../../../component-lib/Molecules/time-picker/EventEHRTimePicker";
import {
  ATTEMPTS,
  BLADE_SIZE,
  COUNCIL_NAME_LIST,
  DEVICE,
  DEVICES,
  DISPOSITION_LIST,
  GCSList,
  getSortedFormData,
  I_GEL_ATTEMPTS_OPTION,
  I_GEL_SIZE_OPTION,
  IS_SUCCESSFUL,
  IV_INSERTION_SIZE,
  JOT_FORM_DATA,
  MA_RESPONSE,
  MA_ROUTE,
  MEDICATIONS_ADMINISTERED_LIST,
  TUBE_SIZE,
} from "../constants";
import moment from "moment";
import EventEHRRadioButton from "../../../component-lib/Molecules/radioButton/EventEHRRadioButton";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import SelectDropdown from "../../../component-lib/Atoms/Select/Select";
import IncidentLocationSelect from "../../../component-lib/Organisms/create-visit-dialog/IncidentLocationSelect";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import CreatePatientForm from "../create-patient-drawer/CreatePatientForm";
import { eventEHRCustomToastMessage } from "../../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import { useDispatch, useSelector } from "react-redux";
import {
  hideLoader,
  showLoader,
} from "../../../component-lib/Molecules/loader/LoaderSlice";
import {
  getLazyLoadingApiResponse,
  getLazyLoadingSearchApiResponse,
} from "../../../utils/constantFunctions";
import EventEHRLazyDropdown from "../../../component-lib/Molecules/lazy-loading-search/EventEHRLazyLoadingSearch";
import { searchIcon } from "../../../assets";
import Input from "../../../component-lib/Atoms/Input/Input";
import ContactInput from "../../../component-lib/Atoms/Input/ContactInput";
import Button from "../../../component-lib/Molecules/button/Button";
import { Button as SimpleButton } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EventEHRCheckbox from "../../../component-lib/Molecules/checkbox/EventEHRCheckbox";
import {
  airwayManagementProps,
  endotrachealIntubationPropertiesProps,
  iGelPropertiesProps,
  procedureDoneProps,
  treatAndReleaseCheckedProps,
} from "./Interface";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded"; // Socket.IO client setup
import Webcam from "react-webcam";
import { useNavigate } from "react-router-dom";
import useDeviceType from "../../../custom-hooks/DeviceType";
import { VALIDATION_CONSTANTS } from "../../../utils/validation-constants/validationConstants";
import { getFacilityList, postDataToJotForm } from "../patientSaga";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { componentKey } from "../patientSlice";
const JotForm = () => {
  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
  };

  const iGelGridStyle = {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "10px",
  };
  const commonHeadingStyle = { color: "#004981", marginBottom: "16px" };
  const accordionBgColor = { backgroundColor: "#85c3f3" };
  const commonTriageFieldHeadingStyle = {
    color: "#57647e",
    fontSize: "14px",
    fontWeight: "500",
  };
  const checkBoxTitleStyle = { color: "#004981", fontWeight: "400" };

  const { facilityList } = useSelector((state: any) => state[componentKey]);

  const deviceType = useDeviceType();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [unitType, setUnitType] = React.useState("");
  const [disposition, setDisposition] = React.useState("");
  const [treatAndReleaseChecked, setTreatAndReleaseChecked] =
    useState<treatAndReleaseCheckedProps>({
      isSelected: false,
      value: "",
    });
  const [gender, setGender] = useState("");
  const [visitor, setVisitor] = useState("");
  const [pageCount, setPageCount] = React.useState(1);
  const [dropdownSearch, setDropdownSearch] = React.useState("");
  const [dropdownOptions, setDropdownOptions] = React.useState<any>([]);
  const [selectedValue, setSelectedValue] = React.useState(null);
  // "Add New Patient" modal (opened from the demographics search dropdown).
  const [openAddNewPatientDialog, setOpenAddNewPatientDialog] =
    React.useState(false);
  const [resetFlag, setResetFlag] = React.useState(false);
  const [timer, setTimer] = React.useState<NodeJS.Timeout | null>(null);
  // Impression/Diagnosis autocomplete — server search/browse state.
  const [impressionSearch, setImpressionSearch] = React.useState("");
  const [impressionPageCount, setImpressionPageCount] = React.useState(1);
  const [impressionTimer, setImpressionTimer] =
    React.useState<NodeJS.Timeout | null>(null);
  const [primaryTreatingClinicianOptions, setPrimaryTreatingClinicianOptions] =
    useState<{ label: string; value: string }[]>([]);
  const [unitDesignationOptions, setUnitDesignationOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [impressionDiagnosisOptions, setImpressionDiagnosisOptions] = useState<
    { label: string; value: string }[]
  >([{ label: "Please Select", value: "" }]);
  const [procedureDone, setProcedureDone] = useState<procedureDoneProps>({
    airwayManagement: false,
    woundCareDressing: false,
    iVPlacement: false,
    medicationsAdministered: false,
    LeadEKG: false,
    splinting: false,
    oxygen: false,
    other: false,
    otherValue: "",
  });
  const [showCamera, setShowCamera] = useState(false);
  const [capturedPhoto, setCapturedPhoto] = useState<string | null>(null);
  const webcamRef = useRef<Webcam>(null);
  const [airwayManagement, setAirwayManagement] =
    useState<airwayManagementProps>({
      bvm: false,
      suctioning: false,
      oPA: false,
      nPA: false,
      iGel: false,
      endotrachealIntubation: false,
      other: false,
      otherOptionValue: "",
    });
  const [iGelProperties, setIGelProperties] = useState<iGelPropertiesProps>({
    size: "",
    attempts: "1",
    successful: "",
    time: "",
  });

  const [
    endotrachealIntubationProperties,
    setEndotrachealIntubationProperties,
  ] = useState<endotrachealIntubationPropertiesProps>({
    device: "vl",
    bladeSize: "Mac 2",
    attempts: "1",
    tubeSize: "5.0",
    successful: "",
    time: "",
  });

  const transportDestinationList = [
    { label: "Select a destination", value: "" }, // Default option
    ...(facilityList?.facilitys?.map((data: any) => ({
      label: data?.name,
      value: data?.id,
    })) || []),
  ];

  // Hospital/Off Site Facility options come from the departments of the
  // "Offsite Transfers" facility (there's no facility picker here — always
  // assume Offsite Transfers). Value is the department NAME so it maps to
  // `hospitalName` and displays directly. Mirrors TransferOffPropertiesForm.
  const offsiteFacility = facilityList?.facilitys?.find((f: any) =>
    f?.name?.toLowerCase()?.includes("offsite")
  );
  const hospitalOffSiteFacilityOptions = [
    { label: "Please Select", value: "" },
    ...(offsiteFacility?.department?.map((d: any) => ({
      label: d?.name,
      value: d?.name,
    })) || []),
  ];

  const validationSchema = Yup.object().shape({
    [JOT_FORM_DATA?.DATE_OF_ENCOUNTER]:
      Yup.string().required("Name is required"),
    [JOT_FORM_DATA?.JAMBOREE_INCIDENT_NUMBER]: Yup.string()
      .matches(
        VALIDATION_CONSTANTS.ACCEPT_CHAR_AND_NUMBER,
        "Jamboree Incident Number can only contain alphanumeric characters"
      )
      .required("Jamboree Incident Number is required"),
    [JOT_FORM_DATA?.TIME_OF_ENCOUNTER]: Yup.string().required(
      "Time of encounter is required"
    ),
    [JOT_FORM_DATA?.PATIENT_NAME]: Yup.string().required(
      "Patient name is required"
    ),
    [JOT_FORM_DATA?.DOB]: Yup.string().required("Date of birth is required"),
    [JOT_FORM_DATA?.AGE]: Yup.string().required("Age is required"),

    [JOT_FORM_DATA?.REGISTRATION_NUMBER]: Yup.string()
      .matches(
        VALIDATION_CONSTANTS.ACCEPT_CHAR_AND_NUMBER,
        "Registration number can only contain alphanumeric characters"
      )
      .required("Registration number is required"),
    // [JOT_FORM_DATA?.INCIDENT_LOCATION]: Yup.string().required(
    //   "Incident location is required"
    // ),
    // [JOT_FORM_DATA?.INCIDENT_DESCRIPTION]: Yup.string().required(
    //   "BRIEF factual description of incident is required"
    // ),
    // [JOT_FORM_DATA?.HOSPITAL_OFF_SITE_FACILITY]: Yup.string().required(
    //   "Hospital/Off Site Facility is required"
    // ),
    // [JOT_FORM_DATA?.HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT]:
    //   Yup.string().required("Transferring Unit is required"),
    [JOT_FORM_DATA?.FINAL_SIGNATURE_TIME]: Yup.string().required(
      "Time Call End is required"
    ),
    [JOT_FORM_DATA?.FINAL_PRIMARY_TREATING_CLINICIAN]: Yup.string().required(
      "Primary Treating Clinician is required"
    ),
    [JOT_FORM_DATA?.FINAL_SIGNATURE_NAME]:
      Yup.string().required("Name is required"),
  });

  React.useEffect(() => {
    if (!resetFlag) {
      if (dropdownSearch && dropdownSearch.length > 0) {
        getDropdownSearchList(dropdownSearch);
      } else {
        getDropdownList(pageCount);
      }
    }
  }, [dropdownSearch, pageCount]);

  React.useEffect(() => {
    if (resetFlag) {
      resetList();
    }
  }, [resetFlag]);

  // Load the facility list on mount so the Off Site Transfer section's
  // Hospital/Off Site Facility dropdown (Offsite Transfers departments) is
  // populated regardless of how the disposition is set.
  React.useEffect(() => {
    dispatch(getFacilityList({ pageNumber: 1, limit: 100 }));
  }, []);

  type ImpressionRow = {
    code: string;
    diagnosisName?: string | null;
    description?: string | null;
    status?: string;
  };

  // Map master-code rows → { label: "code - text", value: label }. Bulk ICD-10
  // codes keep their text in `description` (diagnosisName null) — fall back to it.
  const mapImpressionRows = (rows: ImpressionRow[]) =>
    (Array.isArray(rows) ? rows : [])
      .filter((r) => r?.status === "Active")
      .map((r) => {
        const name = r?.description?.trim() || r?.diagnosisName?.trim();
        const label = name ? `${r?.code} - ${name}` : r?.code;
        return { label, value: label };
      });

  // Browse ICD-10 codes, paginated (appends on scroll). Replaces the previous
  // "load every page" approach so the full catalog isn't preloaded.
  const getImpressionBrowse = async (page: number, reset = false) => {
    try {
      const res = await PatientListService.getAllMasterCode(
        `mastercode?pageNumber=${page}&limit=100`
      );
      const rows = res?.data?.data?.codes ?? res?.data?.codes ?? [];
      const mapped = mapImpressionRows(rows);
      setImpressionDiagnosisOptions((prev) => {
        if (reset || page === 1) return mapped;
        if (
          mapped.length &&
          !prev?.some((o) => o?.value === mapped[0]?.value)
        ) {
          return prev.concat(mapped);
        }
        return prev;
      });
    } catch (error) {
      console.log("impression browse error:", error);
    }
  };

  // Server search: backend `diagnosisName` ORs code + diagnosisName +
  // description, so this finds codes by code OR diagnosis text.
  const getImpressionSearch = async (search: string) => {
    try {
      const res = await PatientListService.getAllMasterCode(
        `mastercode?diagnosisName=${encodeURIComponent(search)}`
      );
      const rows = res?.data?.data?.codes ?? res?.data?.codes ?? [];
      setImpressionDiagnosisOptions(mapImpressionRows(rows));
    } catch (error) {
      console.log("impression search error:", error);
    }
  };

  useEffect(() => {
    const query = impressionSearch?.trim() || "";
    if (query.length === 0) {
      getImpressionBrowse(impressionPageCount);
    } else if (query.length >= 3) {
      // Only search once at least 3 characters are typed
      getImpressionSearch(impressionSearch);
    } else {
      // 1-2 chars: wait for more input (don't query the server)
      setImpressionDiagnosisOptions([]);
    }
  }, [impressionSearch, impressionPageCount]);

  // Debounced search input for the impression dropdown.
  const handleImpressionSearchChange = (data: string) => {
    if (impressionTimer) clearTimeout(impressionTimer);
    const t = setTimeout(() => {
      setImpressionPageCount(1);
      setImpressionSearch(data);
    }, 500);
    setImpressionTimer(t);
  };

  const fetchAllMasterDataByType = async (type: string) => {
    type MasterDataRow = { id: string; name: string; status: string };
    const first = await PatientListService.getMasterDataByType({
      type,
      pageNumber: 1,
      limit: 100,
    });
    let rows: MasterDataRow[] = first?.data?.masterData ?? [];
    const totalPages: number = first?.data?.totalPages ?? 1;
    if (totalPages > 1) {
      const rest = await Promise.all(
        Array.from({ length: totalPages - 1 }, (_, i) =>
          PatientListService.getMasterDataByType({
            type,
            pageNumber: i + 2,
            limit: 100,
          }).then(
            (r: { data?: { masterData?: MasterDataRow[] } }) =>
              r?.data?.masterData ?? []
          )
        )
      );
      rows = rows.concat(...rest);
    }
    return rows
      .filter((r) => r?.status === "Active")
      .map((r) => ({ label: r.name, value: r.name }));
  };

  useEffect(() => {
    (async () => {
      dispatch(showLoader());
      try {
        const [clinicianOptions, designationOptions] = await Promise.all([
          fetchAllMasterDataByType("primary_treating_clinician"),
          fetchAllMasterDataByType("unit_designation"),
        ]);
        setPrimaryTreatingClinicianOptions(clinicianOptions);
        setUnitDesignationOptions(designationOptions);
        // Impression/Diagnosis options load via their own server search/browse
        // effect (getImpressionBrowse / getImpressionSearch).
      } catch (error) {
        console.log("Failed to load master data", error);
      } finally {
        dispatch(hideLoader());
      }
    })();
  }, []);

  const resetList = () => {
    setSelectedValue(null);
    setDropdownSearch("");
    setPageCount(1);
    getDropdownList(1, true);
  };

  // IF SEARCH VALUE  THEN WE ARE GIVEN SOME TIMER
  const handleSearchedValueChange = (data: any) => {
    if (timer) {
      clearTimeout(timer); // Clear the previous timer
    }
    // Set a new timer with your desired delay (e.g., 500ms)
    const newTimer = setTimeout(() => {
      setDropdownSearch(data);
    }, 500); // Adjust the delay as needed (in milliseconds)

    setTimer(newTimer); // Store the timer ID for cleanup
  };

  // Map a participant record to a dropdown option (shared by browse + search so
  // a selection populates DOB/age/phone/etc. the same way regardless of source).
  const mapParticipantOption = (data: any) => ({
    label: `${data?.firstName || data?.lastName ? data?.firstName + " " + data?.lastName : "User"}`,
    value: `${data?.id}`,
    bsaId: data?.bsaId,
    clinicLocation: data?.baseCamp?.name,
    dateOfBirth: data?.dateOfBirth || undefined,
    jun: data?.baseCamp?.unitNumber,
    age: data?.age,
    gender: data?.gender,
    registrationId: data?.registrationId,
    contactNumber: data?.contactNumber,
  });

  // Populate the Demographics fields from a selected/created patient option.
  // Shared by the search-dropdown selection and the "Add New Patient" flow so
  // both fill DOB/age/phone/registration/gender identically.
  const applyDemographicsFromOption = (data: any, setFieldValue: any) => {
    setFieldValue(JOT_FORM_DATA?.PATIENT_NAME, data?.value ? data?.value : "");
    const dobUtc = data?.dateOfBirth ? moment.utc(data?.dateOfBirth) : null;
    if (dobUtc && dobUtc.isValid()) {
      setFieldValue(JOT_FORM_DATA.DOB, dobUtc.format("MM/DD/YYYY"));
      const calculatedAge = moment().diff(
        moment(dobUtc.format("YYYY-MM-DD"), "YYYY-MM-DD"),
        "years"
      );
      setFieldValue(
        JOT_FORM_DATA.AGE,
        calculatedAge >= 0 ? calculatedAge.toString() : "0"
      );
    } else {
      setFieldValue(JOT_FORM_DATA.DOB, undefined);
      if (data?.age != null && data?.age !== "") {
        setFieldValue(JOT_FORM_DATA.AGE, data?.age.toString());
      } else {
        setFieldValue(JOT_FORM_DATA.AGE, "");
      }
    }
    if (data?.contactNumber) {
      setFieldValue(JOT_FORM_DATA.PHONE_NUMBER, data?.contactNumber);
    } else {
      setFieldValue(JOT_FORM_DATA.PHONE_NUMBER, "");
    }
    if (data?.registrationId) {
      setFieldValue(JOT_FORM_DATA.REGISTRATION_NUMBER, data?.registrationId);
    } else {
      setFieldValue(JOT_FORM_DATA.REGISTRATION_NUMBER, "");
    }
    if (data?.gender) {
      setFieldValue(JOT_FORM_DATA.GENDER, data?.gender);
      setGender(data?.gender);
    } else {
      setGender("");
      setFieldValue(JOT_FORM_DATA.GENDER, "");
    }
    setSelectedValue(data);
  };

  // Create a new patient from the modal (opened via the demographics dropdown's
  // "Add New Patient" footer). Calls the service directly (not the create-patient
  // saga, which navigates away) so the EMS jot-form stays put; on success it
  // fills Demographics from the created patient and closes the modal.
  const handleCreateNewPatientForEms = async (
    values: any,
    setFieldValue: any
  ) => {
    try {
      dispatch(showLoader());
      const apiPayload = {
        firstName: values?.firstName,
        lastName: values?.lastName,
        bsaId: values?.bsaId,
        email: values?.email,
        dateOfBirth: values?.dateOfBirth
          ? moment(values?.dateOfBirth).format("YYYY-MM-DD")
          : undefined,
        contactNumber: values?.contact,
        gender: values?.gender,
        campId: values?.clinicLocation,
        emergencyContact: {
          contactName: values?.emergencyContactName,
          contactRelation: values?.emergencyContactRelation,
          contactEmail: values?.emergencyEmail,
          contactNumber: values?.emergencyContactNumber,
        },
        status: "Active",
      };
      const response = await PatientListService.createNewPatient(apiPayload);
      const patient = response?.data?.patient;
      const option = {
        label:
          `${values?.firstName || ""} ${values?.lastName || ""}`.trim() ||
          "User",
        // Demographics uses the PARTICIPANT id (same as the search dropdown),
        // never the patient id.
        value: `${patient?.participantId || values?.id || ""}`,
        bsaId: values?.bsaId,
        dateOfBirth: values?.dateOfBirth
          ? moment(values?.dateOfBirth).format("YYYY-MM-DD")
          : undefined,
        age: undefined,
        gender: values?.gender,
        registrationId: patient?.participant?.registrationId,
        contactNumber: values?.contact,
      };
      applyDemographicsFromOption(option, setFieldValue);
      setOpenAddNewPatientDialog(false);
      eventEHRCustomToastMessage({
        title: response?.data?.message || "Patient created successfully.",
        status: "success",
      });
    } catch (error: any) {
      eventEHRCustomToastMessage({
        title:
          error?.response?.data?.message || "Failed to create the patient.",
        status: "error",
      });
    } finally {
      dispatch(hideLoader());
    }
  };

  // Patients per browse page (infinite scroll appends the next page).
  const PATIENT_PAGE_LIMIT = 20;

  // GET DROPDOWN LIST (browse) — paginated, appends on scroll-to-bottom.
  const getDropdownList = async (page: number, reset = false) => {
    dispatch(showLoader());
    try {
      const response = await getLazyLoadingApiResponse(
        "participant",
        page,
        PATIENT_PAGE_LIMIT
      );
      const participantList = response?.data?.participant || [];
      const mappedPatientData = participantList.map(mapParticipantOption);
      if (mappedPatientData.length > 0) {
        if (reset) {
          setDropdownOptions(mappedPatientData);
          setResetFlag(false);
        } else {
          setDropdownOptions((prev: any) =>
            prev?.some((o: any) => o?.value === mappedPatientData[0]?.value)
              ? prev
              : (prev || []).concat(mappedPatientData)
          );
        }
      } else if (reset) {
        setDropdownOptions([]);
        setResetFlag(false);
      }
    } catch (error) {
      console.log("error:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  // GET DROPDOWN SEARCH LIST
  const getDropdownSearchList = async (search: string) => {
    dispatch(showLoader());
    try {
      const response = await getLazyLoadingSearchApiResponse(
        "participant",
        search
      );
      const participantList = response?.data?.participant || {};
      const mappedPatientData = participantList?.map(mapParticipantOption);
      if (mappedPatientData?.length) {
        setDropdownOptions(mappedPatientData);
      }
    } catch (error) {
      console.log("error:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const capturePhoto = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        setCapturedPhoto(imageSrc);
      }
    }
    setShowCamera(false);
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCapturedPhoto(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeletePhoto = () => {
    setCapturedPhoto(null);
  };

  const initialValues = React.useMemo(
    () => ({
      [JOT_FORM_DATA.DATE_OF_ENCOUNTER]: moment()?.format("MM/DD/YYYY"),
      [JOT_FORM_DATA.JAMBOREE_INCIDENT_NUMBER]: "",
      [JOT_FORM_DATA.TIME_OF_ENCOUNTER]: moment()?.format("HH:mm"),
      [JOT_FORM_DATA.UNIT_TYPE]: "",
      [JOT_FORM_DATA.UNIT_DESIGNATION]: "",
      [JOT_FORM_DATA.PATIENT_NAME]: "",
      [JOT_FORM_DATA.DOB]: undefined,
      [JOT_FORM_DATA.AGE]: "",
      [JOT_FORM_DATA.PHONE_NUMBER]: "",
      [JOT_FORM_DATA.GENDER]: "",
      [JOT_FORM_DATA.VISITOR]: "",
      [JOT_FORM_DATA.REGISTRATION_NUMBER]: "",
      [JOT_FORM_DATA.INCIDENT_LOCATION]: "",
      [JOT_FORM_DATA.INCIDENT_DESCRIPTION]: "",
      [JOT_FORM_DATA.WITNESS_NAME]: "",
      [JOT_FORM_DATA.WITNESS_PHONE_NUMBER]: "",
      [JOT_FORM_DATA.CHIEF_COMPLAINT]: "",
      [JOT_FORM_DATA.SUBJECTIVE]: "",
      [JOT_FORM_DATA.DISPOSITION_TYPE]: "",
      [JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE]: "",
      [JOT_FORM_DATA.TYPE_OF_CARE]: "",
      [JOT_FORM_DATA.TYPE_OF_CARE_NAME]: "",
      [JOT_FORM_DATA.TREAT_AND_RELEASE_USER_NAME]: "",

      vitals: [
        {
          pulse: "",
          sbp: "",
          dbp: "",
          respRate: "",
          spo2: "",
          gcs: "",
          time: "",
        },
      ],

      [JOT_FORM_DATA.OBJECTIVE]: "",
      [JOT_FORM_DATA.ASSESSMENT_AND_PLAN]: "",

      ivInsertionData: [
        {
          size: "",
          attempts: "1",
          successful: "",
          time: moment()?.format("HH:mm"),
        },
      ],
      medicationsAdministeredData: [
        {
          medication: "",
          dose: "",
          route: "",
          response: "",
          time: moment()?.format("HH:mm"),
        },
      ],
      oxygenAdministeredData: [
        {
          device: "",
          lpm: "",
          improvement: "",
          time: moment()?.format("HH:mm"),
        },
      ],

      [JOT_FORM_DATA.IMPRESSION_DIAGNOSIS]: "",
      [JOT_FORM_DATA.TRANSFERRING_UNIT]: "",
      [JOT_FORM_DATA.TREAT_AND_RELEASE_CHECKED]: "",
      [JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_NAME]: "",
      [JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_WITNESS_NAME]: "",
      [JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY]: "",
      [JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT]: "",
      [JOT_FORM_DATA.FINAL_SIGNATURE_TIME]: moment()?.format("HH:mm"),
      [JOT_FORM_DATA.FINAL_PRIMARY_TREATING_CLINICIAN]: "",
      [JOT_FORM_DATA.FINAL_SIGNATURE_NAME]: "",
      [JOT_FORM_DATA.COUNCIL_NAME]: "",
      [JOT_FORM_DATA.STAFF_ASSIGNMENT]: "",
      [JOT_FORM_DATA.JUN]: "",
      [JOT_FORM_DATA.LEAD_INTERPRETATION_TEXT]: "",
    }),
    []
  );

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        const combinedData = {
          ...values,
          capturedPhoto: capturedPhoto,
          procedureDone,
          airwayManagement,
          endotrachealIntubationProperties,
          iGelProperties,
        };
        try {
          const data = getSortedFormData(combinedData);
          const payload = {
            data,
            navigate,
          };

          if (data !== "error") {
            dispatch(postDataToJotForm(payload));
          }
        } catch (error) {
          console.log(error);
        } finally {
          setSubmitting(false); // Reset submitting state
        }
      }}
    >
      {({
        errors,
        values,
        touched,
        isValid,
        dirty,
        setFieldValue,
        handleBlur,
        handleSubmit,
      }: any) => {
        // Type of Care options for the "Treated and Transported" disposition:
        // the selected destination facility's configured departments. Computed
        // (not state) so it also resolves when the form is reopened with a
        // previously saved transport destination.
        const selectedDestinationFacility = facilityList?.facilitys?.find(
          (f: any) => f?.id === values[JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE]
        );
        // Self Care / Nurse Care are no longer defaults; the list is driven
        // purely by the destination facility's configured departments.
        const typeOfCareList = [
          ...(selectedDestinationFacility?.department?.map((d: any) => ({
            label: d?.name,
            value: d?.id,
          })) || []),
        ];
        // The form sits between <main> and the card, so it must carry the flex
        // column through or the card below has no height to fill.
        return (
          <Form
            onSubmit={handleSubmit}
            className="flex-1 min-h-0 flex flex-col"
          >
            <WrapperCard customClasses="m-3 flex-1 min-h-0 flex justify-center bg-[#eaf3ff] overflow-auto">
              <div
                className={`bg-[#eaf3ff] ${deviceType === "mobile" || deviceType === "tablet" || deviceType === "small-tablet" ? "w-[100%]" : "w-[80%] "}   font-semibold`}
              >
                <div className="p-6">
                  <div className="flex">
                    <ArrowBackIosIcon
                      onClick={() => {
                        navigate("/patient");
                      }}
                      className="cursor-pointer"
                    />
                    <div
                      className="cursor-pointer text-[#004981]"
                      onClick={() => {
                        navigate("/patient");
                      }}
                    >
                      Back
                    </div>
                  </div>
                  <h1
                    className="text-center text-[26px] text-[#004981]
"
                  >
                    Jamboree EMS Patient Care Report
                  </h1>
                  <h1
                    className="text-center  text-[#004981] pt-1 pb-3
"
                  >
                    For documentation of care that qualifies as MORE THAN scout
                    rendered first aid.
                  </h1>
                </div>
                <hr
                  style={{
                    height: "2px",
                    borderWidth: "0",
                    color: "#004981",
                    backgroundColor: "#004981",
                  }}
                />{" "}
                {/* Form */}
                <div className="p-6 bg-[#eaf3ff]">
                  {/* DATE OF ENCOUNTER AND TIME OF ENCOUNTER */}
                  <div className="flex flex-wrap gap-4">
                    <div className="w-full sm:w-[30%]">
                      <Heading
                        title="Date of Encounter"
                        isRequired
                        customStyle={commonHeadingStyle}
                      />
                      <DatePicker
                        name={JOT_FORM_DATA?.DATE_OF_ENCOUNTER}
                        value={values[JOT_FORM_DATA.DATE_OF_ENCOUNTER]}
                        onChangeCb={(value) => {
                          setFieldValue(JOT_FORM_DATA.DATE_OF_ENCOUNTER, value);
                        }}
                        // isStarPresent={true}
                        label="Enter Date of Encounter"
                        style={{ width: "100%" }}
                        error={
                          touched[JOT_FORM_DATA.DATE_OF_ENCOUNTER] &&
                          Boolean(errors[JOT_FORM_DATA.DATE_OF_ENCOUNTER])
                        }
                        helperText={
                          touched[JOT_FORM_DATA.DATE_OF_ENCOUNTER]
                            ? errors[JOT_FORM_DATA.DATE_OF_ENCOUNTER]
                            : undefined
                        }
                        maxDate={moment()}
                      />
                    </div>
                    <div className="w-full sm:w-[30%]">
                      <Heading
                        title="Jamboree Incident Number"
                        isRequired
                        customStyle={commonHeadingStyle}
                      />
                      <Input
                        textFieldLabel="Enter Jamboree Incident Number"
                        name={JOT_FORM_DATA.JAMBOREE_INCIDENT_NUMBER}
                        value={
                          values[JOT_FORM_DATA.JAMBOREE_INCIDENT_NUMBER]
                        }
                        onChangeCb={(e) => {
                          setFieldValue(
                            JOT_FORM_DATA.JAMBOREE_INCIDENT_NUMBER,
                            e.target.value
                          );
                        }}
                        size="small"
                        onBlur={handleBlur}
                        error={
                          touched[JOT_FORM_DATA.JAMBOREE_INCIDENT_NUMBER] &&
                          Boolean(
                            errors[JOT_FORM_DATA.JAMBOREE_INCIDENT_NUMBER]
                          )
                        }
                        helperText={
                          touched[JOT_FORM_DATA.JAMBOREE_INCIDENT_NUMBER]
                            ? errors[JOT_FORM_DATA.JAMBOREE_INCIDENT_NUMBER]
                            : undefined
                        }
                      />
                    </div>
                    <div className="w-full sm:w-[30%]">
                      <Heading
                        title="Time of Encounter"
                        isRequired
                        customStyle={commonHeadingStyle}
                      />
                      <EventEHRTimePicker
                        defaultValue={true}
                        name={JOT_FORM_DATA.TIME_OF_ENCOUNTER}
                        value={values[JOT_FORM_DATA.TIME_OF_ENCOUNTER]}
                        onChangeCb={(value) => {
                          setFieldValue(JOT_FORM_DATA.TIME_OF_ENCOUNTER, value);
                        }}
                        // isStarPresent={true}
                        label="Enter Time of Encounter"
                        style={{ width: "100%" }}
                        onBlur={handleBlur}
                        error={
                          touched[JOT_FORM_DATA.TIME_OF_ENCOUNTER] &&
                          Boolean(errors[JOT_FORM_DATA.TIME_OF_ENCOUNTER])
                        }
                        helperText={
                          touched[JOT_FORM_DATA.TIME_OF_ENCOUNTER]
                            ? errors[JOT_FORM_DATA.TIME_OF_ENCOUNTER]
                            : undefined
                        }
                        // ampmFormat={true} // For 12hr time format
                      />
                    </div>
                  </div>
                  {/*  UNIT TYPE */}
                  <div className="ml-2 mr-2 mt-8 mb-4">
                    <Heading
                      title="Unit Type"
                      isRequired
                      customStyle={commonHeadingStyle}
                    />
                    <EventEHRRadioButton
                      selectedValue={unitType}
                      name=""
                      // Wrapping flex so each option stays a unit. The default
                      // (space-x-5 on a plain div) lays them out as inline text,
                      // so a long label's text detached from its radio and the
                      // row ran off the right edge on iPad.
                      grid
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        columnGap: "20px",
                        rowGap: "8px",
                      }}
                      labelCustomStyle={{
                        marginLeft: "10px",
                        color: "#565656",
                      }}
                      optionList={[
                        { label: "Jamboree EMS UTV - BLS", value: "jeu_bls" },
                        { label: "Jamboree EMS UTV - ALS", value: "jeu_als" },
                        {
                          label: "Military FLA - Interfacility Transport ONLY",
                          value: "mf_ito",
                        },
                      ]}
                      handleOnChange={(value: any) => {
                        setUnitType(value);
                        setFieldValue(JOT_FORM_DATA.UNIT_TYPE, value);
                      }}
                    />
                  </div>
                  {/*  UNIT DESIGNATION */}
                  <div className="mt-8">
                    <Heading
                      title="Unit Designation"
                      customStyle={commonHeadingStyle}
                    />
                    <div className="w-[30%]">
                      <SelectDropdown
                        // label="Select Unit Designation"
                        value={values[JOT_FORM_DATA.UNIT_DESIGNATION]}
                        displayEmpty
                        placeholderValue="Please Select"
                        options={unitDesignationOptions}
                        onChangeCb={(e, label) => {
                          setFieldValue(
                            JOT_FORM_DATA.UNIT_DESIGNATION,
                            e.target.value
                          );
                        }}
                        error={
                          touched[JOT_FORM_DATA.UNIT_DESIGNATION] &&
                          Boolean(errors[JOT_FORM_DATA.UNIT_DESIGNATION])
                        }
                        helperText={
                          touched[JOT_FORM_DATA.UNIT_DESIGNATION]
                            ? errors[JOT_FORM_DATA.UNIT_DESIGNATION]
                            : undefined
                        }
                      />
                    </div>
                  </div>

                  {/* ACCORDION */}
                  <div className="mt-8 flex flex-col gap-3">
                    {/* Demographics */}
                    <Accordion sx={accordionBgColor}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        // aria-controls={`panel1-content-${bsaId}`}
                        // id={`panel1-${bsaId}`}
                      >
                        Demographics
                      </AccordionSummary>
                      <AccordionDetails sx={{ backgroundColor: "white" }}>
                        <div
                          className="p-3"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "20px",
                          }}
                        >
                          <div className="w-[60%]">
                            <Heading
                              title="Patient Name"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <EventEHRLazyDropdown
                              // label="Search"
                              placeholder="Search Patient"
                              startIcon={
                                <img
                                  alt="search-icon"
                                  src={searchIcon}
                                  width={"18px"}
                                  height={"18px"}
                                />
                              }
                              onBlur={handleBlur}
                              error={
                                touched[JOT_FORM_DATA?.PATIENT_NAME] &&
                                Boolean(errors[JOT_FORM_DATA?.PATIENT_NAME])
                              }
                              helperText={
                                touched[JOT_FORM_DATA?.PATIENT_NAME]
                                  ? errors[JOT_FORM_DATA?.PATIENT_NAME]
                                  : undefined
                              }
                              noOptionText="Search Patient"
                              dropdownOptions={dropdownOptions}
                              dropdownSearch={dropdownSearch}
                              selectedValue={selectedValue}
                              setDropdownSearch={handleSearchedValueChange}
                              setPageCount={(data) => {
                                setPageCount(data);
                              }}
                              setResetFlag={(data) => {
                                setResetFlag(data);
                              }}
                              setSelectedValue={(data) =>
                                applyDemographicsFromOption(data, setFieldValue)
                              }
                              // Sticky "Add New Patient" footer in the dropdown —
                              // opens the Add New Patient modal.
                              showCreateOption={true}
                              createOptionLabel="+ Add New Patient"
                              onCreateClick={() =>
                                setOpenAddNewPatientDialog(true)
                              }
                            />
                            {/* ADD NEW PATIENT MODAL (same form as Create Clinic
                                Visit → Add New Patient). On create it fills the
                                demographics and stays on the EMS form. */}
                            <Dialog
                              open={openAddNewPatientDialog}
                              onClose={() => setOpenAddNewPatientDialog(false)}
                              maxWidth="md"
                              fullWidth
                            >
                              <DialogTitle
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "18px",
                                }}
                              >
                                Add New Patient
                                <IconButton
                                  aria-label="close"
                                  onClick={() =>
                                    setOpenAddNewPatientDialog(false)
                                  }
                                  sx={(theme) => ({
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: theme.palette.grey[500],
                                  })}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </DialogTitle>
                              <DialogContent dividers>
                                {openAddNewPatientDialog && (
                                  <CreatePatientForm
                                    handlePatientFieldsData={(vals) =>
                                      handleCreateNewPatientForEms(
                                        vals,
                                        setFieldValue
                                      )
                                    }
                                  />
                                )}
                              </DialogContent>
                            </Dialog>
                          </div>
                          <div className="w-[60%]">
                            <Heading
                              title="Date of Birth"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <DatePicker
                              name={JOT_FORM_DATA?.DOB}
                              value={values[JOT_FORM_DATA.DOB]}
                              onChangeCb={(value) => {
                                setFieldValue(JOT_FORM_DATA.DOB, value);

                                if (value) {
                                  const calculatedAge = moment().diff(
                                    moment(value, "YYYY-MM-DD"),
                                    "years"
                                  );
                                  // setAge(calculatedAge.toString());
                                  setFieldValue(
                                    JOT_FORM_DATA.AGE,
                                    calculatedAge.toString()
                                  );
                                } else {
                                  setFieldValue(JOT_FORM_DATA.AGE, "");
                                }
                              }}
                              // isStarPresent={true}
                              label="Date Of Birth"
                              style={{ width: "100%" }}
                              error={
                                touched[JOT_FORM_DATA.DOB] &&
                                Boolean(errors[JOT_FORM_DATA.DOB])
                              }
                              helperText={
                                touched[JOT_FORM_DATA.DOB]
                                  ? errors[JOT_FORM_DATA.DOB]
                                  : undefined
                              }
                              maxDate={moment()}
                            />
                          </div>
                          <div className="w-[60%]">
                            <Heading
                              title="Age"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <Input
                              // disabled={true}
                              type="number"
                              placeholder=""
                              name={JOT_FORM_DATA.AGE}
                              value={values[JOT_FORM_DATA.AGE]}
                              onChangeCb={(e) => {
                                setFieldValue(
                                  JOT_FORM_DATA.AGE,
                                  e.target.value
                                );
                              }}
                              size="small"
                              onBlur={handleBlur}
                              error={
                                touched[JOT_FORM_DATA.AGE] &&
                                Boolean(errors[JOT_FORM_DATA.AGE])
                              }
                              helperText={
                                touched[JOT_FORM_DATA.AGE]
                                  ? errors[JOT_FORM_DATA.AGE]
                                  : undefined
                              }
                            />
                          </div>
                          <div className="w-[60%]">
                            <Heading
                              title="Phone Number"
                              customStyle={commonHeadingStyle}
                            />
                            <ContactInput
                              textFieldLabel="Enter Phone Number"
                              name={JOT_FORM_DATA.PHONE_NUMBER}
                              value={values[JOT_FORM_DATA.PHONE_NUMBER]}
                              onChangeCb={(value) => {
                                setFieldValue(
                                  JOT_FORM_DATA.PHONE_NUMBER,
                                  value
                                );
                              }}
                              size="small"
                              onBlur={handleBlur}
                              error={
                                touched[JOT_FORM_DATA.PHONE_NUMBER] &&
                                Boolean(errors[JOT_FORM_DATA.PHONE_NUMBER])
                              }
                              helperText={
                                touched[JOT_FORM_DATA.PHONE_NUMBER]
                                  ? errors[JOT_FORM_DATA.PHONE_NUMBER]
                                  : undefined
                              }
                              isContactNumber={true}
                            />
                          </div>
                          <div>
                            <Heading
                              title="Gender"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />

                            <EventEHRRadioButton
                              selectedValue={gender}
                              name=""
                              grid
                              style={gridStyle}
                              labelCustomStyle={{
                                marginLeft: "10px",
                                color: "#565656",
                              }}
                              optionList={[
                                {
                                  label: "Male",
                                  value: "Male",
                                },
                                {
                                  label: "Female",
                                  value: "Female",
                                },
                                {
                                  label: "Non-Binary",
                                  value: "Non-binary",
                                },
                                {
                                  label: "Other",
                                  value: "Other",
                                },
                              ]}
                              handleOnChange={(value: any) => {
                                setGender(value);
                                setFieldValue(JOT_FORM_DATA.GENDER, value);
                              }}
                            />
                            {gender === "Other" && (
                              <div className="pt-2">
                                <Input
                                  textFieldLabel="Please type another option here"
                                  name={JOT_FORM_DATA.OTHER}
                                  value={values[JOT_FORM_DATA.OTHER]}
                                  onChangeCb={(e) => {
                                    setFieldValue(
                                      JOT_FORM_DATA.OTHER,
                                      e.target.value
                                    );
                                  }}
                                  onBlur={handleBlur}
                                  size="small"
                                  error={
                                    touched[JOT_FORM_DATA.OTHER] &&
                                    Boolean(errors[JOT_FORM_DATA.OTHER])
                                  }
                                  helperText={
                                    touched[JOT_FORM_DATA.OTHER]
                                      ? errors[JOT_FORM_DATA.OTHER]
                                      : undefined
                                  }
                                />
                              </div>
                            )}
                          </div>
                          <div>
                            <Heading
                              title="Staff, Participant or Visitor"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />

                            <EventEHRRadioButton
                              selectedValue={visitor}
                              name=""
                              grid
                              style={gridStyle}
                              labelCustomStyle={{
                                marginLeft: "10px",
                                color: "#565656",
                              }}
                              optionList={[
                                { label: "Staff", value: "jst" },
                                { label: "Participant", value: "participant" },
                                { label: "Visitor", value: "visitor" },
                                { label: "Exhibitor", value: "exhibitor" },
                                {
                                  label: "Summit Staff (FT or Seasonal)",
                                  value: "summitStaff",
                                },
                              ]}
                              handleOnChange={(value: any) => {
                                setVisitor(value);
                                setFieldValue(JOT_FORM_DATA.VISITOR, value);
                              }}
                            />
                          </div>

                          <div className="w-[60%]">
                            <Heading
                              title="Registration Number"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <Input
                              textFieldLabel="Enter Registration Number"
                              name={JOT_FORM_DATA.REGISTRATION_NUMBER}
                              value={values[JOT_FORM_DATA.REGISTRATION_NUMBER]}
                              onChangeCb={(e) => {
                                setFieldValue(
                                  JOT_FORM_DATA.REGISTRATION_NUMBER,
                                  e.target.value
                                );
                              }}
                              size="small"
                              onBlur={handleBlur}
                              error={
                                touched[JOT_FORM_DATA.REGISTRATION_NUMBER] &&
                                Boolean(
                                  errors[JOT_FORM_DATA.REGISTRATION_NUMBER]
                                )
                              }
                              helperText={
                                touched[JOT_FORM_DATA.REGISTRATION_NUMBER]
                                  ? errors[JOT_FORM_DATA.REGISTRATION_NUMBER]
                                  : undefined
                              }
                            />
                          </div>
                        </div>
                        {/* <div> */}
                        {visitor === "jst" && (
                          <div className="p-3">
                            <div className="w-[30%]">
                              <Heading
                                title="Council Name"
                                customStyle={commonHeadingStyle}
                              />
                              <SelectDropdown
                                // label="Please Select"
                                displayEmpty
                                name={JOT_FORM_DATA.COUNCIL_NAME}
                                value={values[JOT_FORM_DATA.COUNCIL_NAME]}
                                options={COUNCIL_NAME_LIST}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.COUNCIL_NAME,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                error={
                                  touched[JOT_FORM_DATA.COUNCIL_NAME] &&
                                  Boolean(errors[JOT_FORM_DATA.COUNCIL_NAME])
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.GENDER]
                                    ? errors[JOT_FORM_DATA.GENDER]
                                    : undefined
                                }
                              />
                            </div>
                            <div className="w-[30%] mt-8">
                              <Heading
                                title="Staff Assignment"
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                maxLength={100}
                                name={JOT_FORM_DATA.STAFF_ASSIGNMENT}
                                value={values[JOT_FORM_DATA.STAFF_ASSIGNMENT]}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.STAFF_ASSIGNMENT,
                                    e.target.value
                                  );
                                }}
                                size="small"
                                onBlur={handleBlur}
                                error={
                                  touched[JOT_FORM_DATA.STAFF_ASSIGNMENT] &&
                                  Boolean(
                                    errors[JOT_FORM_DATA.STAFF_ASSIGNMENT]
                                  )
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.STAFF_ASSIGNMENT]
                                    ? errors[JOT_FORM_DATA.STAFF_ASSIGNMENT]
                                    : undefined
                                }
                              />
                              <span className="text-[10px] text-[#004981]">
                                i.e. Aquatics, Shooting Sports, Wheels
                              </span>
                            </div>
                          </div>
                        )}

                        {visitor === "participant" && (
                          <div className="p-3">
                            <div className="w-[30%]">
                              <Heading
                                title="Jamboree Unit Number (on credential)"
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                // textFieldLabel="Jamboree Unit Number"
                                type="number"
                                name={JOT_FORM_DATA.JUN}
                                value={values[JOT_FORM_DATA.JUN]}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.JUN,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                size="small"
                                error={
                                  touched[JOT_FORM_DATA.JUN] &&
                                  Boolean(errors[JOT_FORM_DATA.JUN])
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.JUN]
                                    ? errors[JOT_FORM_DATA.JUN]
                                    : undefined
                                }
                              />
                            </div>
                            <div className="w-[30%] mt-5">
                              <Heading
                                title="Council Name"
                                customStyle={commonHeadingStyle}
                              />
                              <SelectDropdown
                                // label="Please Select"
                                displayEmpty
                                name={JOT_FORM_DATA.COUNCIL_NAME}
                                value={values[JOT_FORM_DATA.COUNCIL_NAME]}
                                options={COUNCIL_NAME_LIST}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.COUNCIL_NAME,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                error={
                                  touched[JOT_FORM_DATA.COUNCIL_NAME] &&
                                  Boolean(errors[JOT_FORM_DATA.COUNCIL_NAME])
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.COUNCIL_NAME]
                                    ? errors[JOT_FORM_DATA.COUNCIL_NAME]
                                    : undefined
                                }
                              />
                            </div>
                          </div>
                        )}

                        {(visitor === "visitor" || visitor === "exhibitor") && (
                          <div className="p-3 text-[#004981]">
                            <h1 className="text-[20px]">
                              STOP! You have selected Visitor or Exhibitor!
                            </h1>
                            <h3 className="text-[14px]">
                              A visitor or exhibitor CANNOT be treated at a
                              Jamboree Medical Facility. You must either: 1)
                              Treat and obtain an RMA; 2) Call for JanCare EMS
                              to respond to evaluate, treat and disposition the
                              patient.
                            </h3>
                          </div>
                        )}

                        {visitor === "summitStaff" && (
                          <div className="p-3">
                            <div className="w-[30%] mt-3">
                              <Heading
                                title="Staff Assignment"
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                maxLength={100}
                                name={JOT_FORM_DATA.STAFF_ASSIGNMENT}
                                value={values[JOT_FORM_DATA.STAFF_ASSIGNMENT]}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.STAFF_ASSIGNMENT,
                                    e.target.value
                                  );
                                }}
                                size="small"
                                onBlur={handleBlur}
                                error={
                                  touched[JOT_FORM_DATA.STAFF_ASSIGNMENT] &&
                                  Boolean(
                                    errors[JOT_FORM_DATA.STAFF_ASSIGNMENT]
                                  )
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.STAFF_ASSIGNMENT]
                                    ? errors[JOT_FORM_DATA.STAFF_ASSIGNMENT]
                                    : undefined
                                }
                              />
                              <span className="text-[10px] text-[#004981]">
                                i.e. Aquatics, Shooting Sports, Wheels
                              </span>
                            </div>
                          </div>
                        )}

                        {/* </div> */}
                      </AccordionDetails>
                    </Accordion>
                    {/*  Incident Details */}
                    {unitType !== "mf_ito" && (
                      <Accordion sx={accordionBgColor}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          Incident Details
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: "white" }}>
                          <div className="p-3">
                            <div className="w-[30%]">
                              <Heading
                                title="Incident Location"
                                isRequired
                                customStyle={commonHeadingStyle}
                              />
                              <IncidentLocationSelect
                                value={values[JOT_FORM_DATA.INCIDENT_LOCATION]}
                                onChange={(val: string) =>
                                  setFieldValue(
                                    JOT_FORM_DATA.INCIDENT_LOCATION,
                                    val
                                  )
                                }
                                onBlur={handleBlur}
                                error={
                                  touched[JOT_FORM_DATA.INCIDENT_LOCATION] &&
                                  Boolean(
                                    errors[JOT_FORM_DATA.INCIDENT_LOCATION]
                                  )
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.INCIDENT_LOCATION]
                                    ? errors[JOT_FORM_DATA.INCIDENT_LOCATION]
                                    : undefined
                                }
                              />
                            </div>
                            <div className="pt-5">
                              <Heading
                                title="Please provide BRIEF factual description of incident."
                                customStyle={commonHeadingStyle}
                                isRequired
                              />
                              <Input
                                multiline={true}
                                rows={4}
                                name={JOT_FORM_DATA.INCIDENT_DESCRIPTION}
                                value={
                                  values[JOT_FORM_DATA.INCIDENT_DESCRIPTION]
                                }
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.INCIDENT_DESCRIPTION,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                size="small"
                                error={
                                  touched[JOT_FORM_DATA.INCIDENT_DESCRIPTION] &&
                                  Boolean(
                                    errors[JOT_FORM_DATA.INCIDENT_DESCRIPTION]
                                  )
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.INCIDENT_DESCRIPTION]
                                    ? errors[JOT_FORM_DATA.INCIDENT_DESCRIPTION]
                                    : undefined
                                }
                              />
                            </div>
                            <div className="p-3 pt-8">
                              <div style={gridStyle} className="mt-8">
                                <div className="w-[60%]">
                                  <Heading
                                    title="Witness Name"
                                    customStyle={commonHeadingStyle}
                                  />
                                  <Input
                                    maxLength={100}
                                    name={JOT_FORM_DATA.WITNESS_NAME}
                                    value={values[JOT_FORM_DATA.WITNESS_NAME]}
                                    onChangeCb={(e) => {
                                      setFieldValue(
                                        JOT_FORM_DATA.WITNESS_NAME,
                                        e.target.value
                                      );
                                    }}
                                    size="small"
                                    onBlur={handleBlur}
                                    error={
                                      touched[JOT_FORM_DATA.WITNESS_NAME] &&
                                      Boolean(
                                        errors[JOT_FORM_DATA.WITNESS_NAME]
                                      )
                                    }
                                    helperText={
                                      touched[JOT_FORM_DATA.WITNESS_NAME]
                                        ? errors[JOT_FORM_DATA.WITNESS_NAME]
                                        : undefined
                                    }
                                  />
                                </div>
                                <div className="w-[60%]">
                                  <Heading
                                    title="Witness Phone Number"
                                    customStyle={commonHeadingStyle}
                                  />
                                  <ContactInput
                                    textFieldLabel="Enter Phone Number"
                                    name={JOT_FORM_DATA.WITNESS_PHONE_NUMBER}
                                    value={
                                      values[JOT_FORM_DATA.WITNESS_PHONE_NUMBER]
                                    }
                                    onChangeCb={(value) => {
                                      setFieldValue(
                                        JOT_FORM_DATA.WITNESS_PHONE_NUMBER,
                                        value
                                      );
                                    }}
                                    size="small"
                                    onBlur={handleBlur}
                                    error={
                                      touched[
                                        JOT_FORM_DATA.WITNESS_PHONE_NUMBER
                                      ] &&
                                      Boolean(
                                        errors[
                                          JOT_FORM_DATA.WITNESS_PHONE_NUMBER
                                        ]
                                      )
                                    }
                                    helperText={
                                      touched[
                                        JOT_FORM_DATA.WITNESS_PHONE_NUMBER
                                      ]
                                        ? errors[
                                            JOT_FORM_DATA.WITNESS_PHONE_NUMBER
                                          ]
                                        : undefined
                                    }
                                    isContactNumber={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    {/*   SOAP and Procedures
                     */}
                    {unitType !== "mf_ito" && (
                      <Accordion sx={accordionBgColor}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          SOAP and Procedures
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: "white" }}>
                          {/* Vital Signs Section */}
                          <div className="p-3">
                            <div className="w-[60%]">
                              <Heading
                                title="Chief Complaint"
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                name={JOT_FORM_DATA.CHIEF_COMPLAINT}
                                value={values[JOT_FORM_DATA.CHIEF_COMPLAINT]}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.CHIEF_COMPLAINT,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                size="small"
                                error={
                                  touched[JOT_FORM_DATA.CHIEF_COMPLAINT] &&
                                  Boolean(errors[JOT_FORM_DATA.CHIEF_COMPLAINT])
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.CHIEF_COMPLAINT]
                                    ? errors[JOT_FORM_DATA.CHIEF_COMPLAINT]
                                    : undefined
                                }
                              />
                            </div>

                            <div className="pt-5">
                              <Heading
                                title="Subjective"
                                isRequired={true}
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                multiline={true}
                                rows={5}
                                // textFieldLabel="Enter Chief Complaint"
                                name={JOT_FORM_DATA.SUBJECTIVE}
                                value={values[JOT_FORM_DATA.SUBJECTIVE]}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.SUBJECTIVE,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                size="small"
                                error={
                                  touched[JOT_FORM_DATA.SUBJECTIVE] &&
                                  Boolean(errors[JOT_FORM_DATA.SUBJECTIVE])
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.SUBJECTIVE]
                                    ? errors[JOT_FORM_DATA.SUBJECTIVE]
                                    : undefined
                                }
                              />
                            </div>

                            <FieldArray name="vitals">
                              {({ push, remove }) => (
                                <div className="pt-7">
                                  <Heading
                                    title="Vital Signs - Please Scroll To see all fields"
                                    isRequired
                                    customStyle={commonHeadingStyle}
                                  />
                                  {values.vitals.map(
                                    (vital: any, index: any) => (
                                      <div
                                        key={index}
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <div>
                                          <span
                                            style={
                                              commonTriageFieldHeadingStyle
                                            }
                                          >
                                            Pulse
                                          </span>
                                          <Input
                                            type="number"
                                            name={`vitals.${index}.pulse`}
                                            value={vital.pulse}
                                            onChangeCb={(e) => {
                                              setFieldValue(
                                                `vitals.${index}.pulse`,
                                                e.target.value
                                              );
                                            }}
                                            size="small"
                                          />
                                        </div>
                                        <div>
                                          <span
                                            style={
                                              commonTriageFieldHeadingStyle
                                            }
                                          >
                                            SBP
                                          </span>

                                          <Input
                                            type="number"
                                            name={`vitals.${index}.sbp`}
                                            value={vital.sbp}
                                            onChangeCb={(e) => {
                                              setFieldValue(
                                                `vitals.${index}.sbp`,
                                                e.target.value
                                              );
                                            }}
                                            size="small"
                                          />
                                        </div>

                                        <div>
                                          <span
                                            style={
                                              commonTriageFieldHeadingStyle
                                            }
                                          >
                                            DBP
                                          </span>
                                          <Input
                                            type="number"
                                            name={`vitals.${index}.dbp`}
                                            value={vital.dbp}
                                            onChangeCb={(e) => {
                                              setFieldValue(
                                                `vitals.${index}.dbp`,
                                                e.target.value
                                              );
                                            }}
                                            size="small"
                                          />
                                        </div>

                                        <div>
                                          <span
                                            style={
                                              commonTriageFieldHeadingStyle
                                            }
                                          >
                                            Resp Rate
                                          </span>
                                          <Input
                                            type="number"
                                            name={`vitals.${index}.respRate`}
                                            value={vital.respRate}
                                            onChangeCb={(e) => {
                                              setFieldValue(
                                                `vitals.${index}.respRate`,
                                                e.target.value
                                              );
                                            }}
                                            size="small"
                                          />
                                        </div>

                                        <div>
                                          <span
                                            style={
                                              commonTriageFieldHeadingStyle
                                            }
                                          >
                                            SpO2
                                          </span>
                                          <Input
                                            type="number"
                                            name={`vitals.${index}.spo2`}
                                            value={vital.spo2}
                                            onChangeCb={(e) => {
                                              setFieldValue(
                                                `vitals.${index}.spo2`,
                                                e.target.value
                                              );
                                            }}
                                            size="small"
                                          />
                                        </div>
                                        <div>
                                          <span
                                            style={
                                              commonTriageFieldHeadingStyle
                                            }
                                          >
                                            GCS
                                          </span>
                                          <SelectDropdown
                                            // label="Select Type of Care"
                                            value={vital.gcs}
                                            displayEmpty
                                            options={GCSList}
                                            onChangeCb={(e, label) => {
                                              setFieldValue(
                                                `vitals.${index}.gcs`,
                                                e.target.value
                                              );
                                            }}
                                          />
                                        </div>

                                        <div>
                                          <span
                                            style={
                                              commonTriageFieldHeadingStyle
                                            }
                                          >
                                            Time
                                          </span>
                                          <EventEHRTimePicker
                                            defaultValue={true}
                                            name={`vitals.${index}.time`}
                                            value={vital.time}
                                            onChangeCb={(value: any) => {
                                              setFieldValue(
                                                `vitals.${index}.time`,
                                                value
                                              );
                                            }}
                                            // isStarPresent={true}
                                            // label="Enter Time"
                                            style={{ width: "100%" }}
                                          />
                                        </div>

                                        {/* Remove Button */}
                                        {values.vitals.length > 1 && (
                                          <div className="pt-7 cursor-pointer">
                                            <DeleteIcon
                                              onClick={() => remove(index)}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    )
                                  )}

                                  {/* Add Vital Button */}
                                  <Button
                                    type="button"
                                    label={"+ Addtl Vitals"}
                                    variant="contained"
                                    onClickCb={() =>
                                      push({
                                        pulse: "",
                                        sbp: "",
                                        dbp: "",
                                        respRate: "",
                                        spo2: "",
                                        gcs: "",
                                        time: "",
                                      })
                                    }
                                    // style={{
                                    //   padding: "8px 55px",
                                    //   fontSize: "16px",
                                    // }}
                                  ></Button>
                                </div>
                              )}
                            </FieldArray>

                            <div className="pt-5">
                              <Heading
                                title="Objective/Exam Findings"
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                multiline={true}
                                rows={5}
                                name={JOT_FORM_DATA.OBJECTIVE}
                                value={values[JOT_FORM_DATA.OBJECTIVE]}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.OBJECTIVE,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                size="small"
                                error={
                                  touched[JOT_FORM_DATA.OBJECTIVE] &&
                                  Boolean(errors[JOT_FORM_DATA.OBJECTIVE])
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.OBJECTIVE]
                                    ? errors[JOT_FORM_DATA.OBJECTIVE]
                                    : undefined
                                }
                              />
                            </div>

                            <div className="pt-5">
                              <Heading
                                title="Assessment and Plan & Treatment"
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                multiline={true}
                                rows={5}
                                name={JOT_FORM_DATA.ASSESSMENT_AND_PLAN}
                                value={
                                  values[JOT_FORM_DATA.ASSESSMENT_AND_PLAN]
                                }
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.ASSESSMENT_AND_PLAN,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                size="small"
                                error={
                                  touched[JOT_FORM_DATA.ASSESSMENT_AND_PLAN] &&
                                  Boolean(
                                    errors[JOT_FORM_DATA.ASSESSMENT_AND_PLAN]
                                  )
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.ASSESSMENT_AND_PLAN]
                                    ? errors[JOT_FORM_DATA.ASSESSMENT_AND_PLAN]
                                    : undefined
                                }
                              />
                              <span className="text-[10px] text-[#004981]">
                                Please describe any splinting, wound care or
                                other BLS management techniques here.
                              </span>
                            </div>

                            <div className="pt-5">
                              <Heading
                                title="Procedures Done"
                                customStyle={commonHeadingStyle}
                              />
                              <div className="flex flex-col gap-2">
                                <EventEHRCheckbox
                                  checkboxSelected={
                                    procedureDone?.airwayManagement
                                  }
                                  label="Airway Management"
                                  customLabelStyle={checkBoxTitleStyle}
                                  callback={() => {
                                    setProcedureDone((prevData: any) => ({
                                      ...prevData,
                                      airwayManagement:
                                        !procedureDone?.airwayManagement,
                                    }));
                                  }}
                                />
                                <EventEHRCheckbox
                                  checkboxSelected={
                                    procedureDone?.woundCareDressing
                                  }
                                  label="Wound Care/Dressing"
                                  customLabelStyle={checkBoxTitleStyle}
                                  callback={() => {
                                    setProcedureDone((prevData: any) => ({
                                      ...prevData,
                                      woundCareDressing:
                                        !procedureDone?.woundCareDressing,
                                    }));
                                  }}
                                />
                                <EventEHRCheckbox
                                  checkboxSelected={procedureDone?.iVPlacement}
                                  label="IV Placement"
                                  customLabelStyle={checkBoxTitleStyle}
                                  callback={() => {
                                    setProcedureDone((prevData: any) => ({
                                      ...prevData,
                                      iVPlacement: !procedureDone?.iVPlacement,
                                    }));
                                  }}
                                />
                                <EventEHRCheckbox
                                  checkboxSelected={
                                    procedureDone?.medicationsAdministered
                                  }
                                  label="Medications Administered"
                                  customLabelStyle={checkBoxTitleStyle}
                                  callback={() => {
                                    setProcedureDone((prevData: any) => ({
                                      ...prevData,
                                      medicationsAdministered:
                                        !procedureDone?.medicationsAdministered,
                                    }));
                                  }}
                                />
                                <EventEHRCheckbox
                                  checkboxSelected={procedureDone?.LeadEKG}
                                  label="12 Lead EKG"
                                  customLabelStyle={checkBoxTitleStyle}
                                  callback={() => {
                                    setProcedureDone((prevData: any) => ({
                                      ...prevData,
                                      LeadEKG: !procedureDone?.LeadEKG,
                                    }));
                                    if (!procedureDone?.LeadEKG) {
                                      setShowCamera(true);
                                    } else {
                                      setShowCamera(false);
                                    }
                                  }}
                                />
                                <EventEHRCheckbox
                                  checkboxSelected={procedureDone?.splinting}
                                  label="Splinting"
                                  customLabelStyle={checkBoxTitleStyle}
                                  callback={() => {
                                    setProcedureDone((prevData: any) => ({
                                      ...prevData,
                                      splinting: !procedureDone?.splinting,
                                    }));
                                  }}
                                />
                                <EventEHRCheckbox
                                  checkboxSelected={procedureDone?.oxygen}
                                  label="Oxygen"
                                  customLabelStyle={checkBoxTitleStyle}
                                  callback={() => {
                                    setProcedureDone((prevData: any) => ({
                                      ...prevData,
                                      oxygen: !procedureDone?.oxygen,
                                    }));
                                  }}
                                />
                                <EventEHRCheckbox
                                  checkboxSelected={procedureDone?.other}
                                  label="Other"
                                  customLabelStyle={checkBoxTitleStyle}
                                  callback={() => {
                                    setProcedureDone((prevData: any) => ({
                                      ...prevData,
                                      other: !procedureDone?.other,
                                    }));
                                  }}
                                />

                                {procedureDone?.other && (
                                  <div className="pt-2 w-[50%]">
                                    <Input
                                      textFieldLabel="Please type another option here"
                                      // name={"other"}
                                      value={procedureDone?.otherValue}
                                      onChangeCb={(e) => {
                                        setProcedureDone((prevData: any) => ({
                                          ...prevData,
                                          otherValue: e.target.value,
                                        }));
                                      }}
                                      size="small"
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                            {/* If Airway Management Selected */}
                            {procedureDone?.airwayManagement && (
                              <div className="pt-5">
                                <Heading
                                  title="Airway Management"
                                  customStyle={commonHeadingStyle}
                                />
                                <div className="flex flex-col gap-2">
                                  <EventEHRCheckbox
                                    checkboxSelected={airwayManagement?.bvm}
                                    label="BVM"
                                    customLabelStyle={checkBoxTitleStyle}
                                    callback={() => {
                                      setAirwayManagement((prevData: any) => ({
                                        ...prevData,
                                        bvm: !airwayManagement?.bvm,
                                      }));
                                    }}
                                  />
                                  <EventEHRCheckbox
                                    checkboxSelected={
                                      airwayManagement?.suctioning
                                    }
                                    label="Suctioning"
                                    customLabelStyle={checkBoxTitleStyle}
                                    callback={() => {
                                      setAirwayManagement((prevData: any) => ({
                                        ...prevData,
                                        suctioning:
                                          !airwayManagement?.suctioning,
                                      }));
                                    }}
                                  />
                                  <EventEHRCheckbox
                                    checkboxSelected={airwayManagement?.oPA}
                                    label="OPA"
                                    customLabelStyle={checkBoxTitleStyle}
                                    callback={() => {
                                      setAirwayManagement((prevData: any) => ({
                                        ...prevData,
                                        oPA: !airwayManagement?.oPA,
                                      }));
                                    }}
                                  />
                                  <EventEHRCheckbox
                                    checkboxSelected={airwayManagement?.nPA}
                                    label="NPA"
                                    customLabelStyle={checkBoxTitleStyle}
                                    callback={() => {
                                      setAirwayManagement((prevData: any) => ({
                                        ...prevData,
                                        nPA: !airwayManagement?.nPA,
                                      }));
                                    }}
                                  />
                                  <EventEHRCheckbox
                                    checkboxSelected={airwayManagement?.iGel}
                                    label="iGel"
                                    customLabelStyle={checkBoxTitleStyle}
                                    callback={() => {
                                      setAirwayManagement((prevData: any) => ({
                                        ...prevData,
                                        iGel: !airwayManagement?.iGel,
                                      }));
                                    }}
                                  />
                                  <EventEHRCheckbox
                                    checkboxSelected={
                                      airwayManagement?.endotrachealIntubation
                                    }
                                    label="Endotracheal Intubation"
                                    customLabelStyle={checkBoxTitleStyle}
                                    callback={() => {
                                      setAirwayManagement((prevData: any) => ({
                                        ...prevData,
                                        endotrachealIntubation:
                                          !airwayManagement?.endotrachealIntubation,
                                      }));
                                    }}
                                  />
                                  <EventEHRCheckbox
                                    checkboxSelected={airwayManagement?.other}
                                    label="Other"
                                    customLabelStyle={checkBoxTitleStyle}
                                    callback={() => {
                                      setAirwayManagement((prevData: any) => ({
                                        ...prevData,
                                        other: !airwayManagement?.other,
                                      }));
                                    }}
                                  />
                                  {airwayManagement?.other && (
                                    <div className="pt-2 w-[50%]">
                                      <Input
                                        textFieldLabel="Please type another option here"
                                        // name={"other"}
                                        value={
                                          airwayManagement?.otherOptionValue
                                        }
                                        onChangeCb={(e) => {
                                          setAirwayManagement(
                                            (prevData: any) => ({
                                              ...prevData,
                                              otherOptionValue: e.target.value,
                                            })
                                          );
                                        }}
                                        size="small"
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}

                            {procedureDone?.airwayManagement &&
                              airwayManagement?.endotrachealIntubation && (
                                <div className="pt-5">
                                  <Heading
                                    isRequired
                                    title="Endotracheal Intubation"
                                    customStyle={commonHeadingStyle}
                                  />
                                  <div className="flex gap-5">
                                    <div>
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Device
                                      </span>
                                      <SelectDropdown
                                        // label="Select Type of Care"
                                        value={
                                          endotrachealIntubationProperties?.device
                                        }
                                        displayEmpty
                                        options={DEVICES}
                                        onChangeCb={(e, label) => {
                                          setEndotrachealIntubationProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              device: e.target.value,
                                            })
                                          );
                                        }}
                                      />
                                    </div>

                                    <div>
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Blade Size
                                      </span>
                                      <SelectDropdown
                                        // label="Select Type of Care"
                                        value={
                                          endotrachealIntubationProperties?.bladeSize
                                        }
                                        displayEmpty
                                        options={BLADE_SIZE}
                                        onChangeCb={(e, label) => {
                                          setEndotrachealIntubationProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              bladeSize: e.target.value,
                                            })
                                          );
                                        }}
                                      />
                                    </div>

                                    <div>
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Attempts
                                      </span>
                                      <SelectDropdown
                                        // label="Select Type of Care"
                                        value={
                                          endotrachealIntubationProperties?.attempts
                                        }
                                        displayEmpty
                                        options={ATTEMPTS}
                                        onChangeCb={(e, label) => {
                                          setEndotrachealIntubationProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              attempts: e.target.value,
                                            })
                                          );
                                        }}
                                      />
                                    </div>

                                    <div>
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Tube Size
                                      </span>
                                      <SelectDropdown
                                        // label="Select Type of Care"
                                        value={
                                          endotrachealIntubationProperties?.tubeSize
                                        }
                                        displayEmpty
                                        options={TUBE_SIZE}
                                        onChangeCb={(e, label) => {
                                          setEndotrachealIntubationProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              tubeSize: e.target.value,
                                            })
                                          );
                                        }}
                                      />
                                    </div>

                                    <div className="ml-3">
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Successful?
                                      </span>
                                      <EventEHRRadioButton
                                        selectedValue={
                                          endotrachealIntubationProperties?.successful
                                        }
                                        name=""
                                        grid
                                        style={iGelGridStyle}
                                        labelCustomStyle={{
                                          marginLeft: "10px",
                                          color: "#565656",
                                        }}
                                        optionList={IS_SUCCESSFUL}
                                        handleOnChange={(value: any) => {
                                          setEndotrachealIntubationProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              successful: value,
                                            })
                                          );
                                        }}
                                      />
                                    </div>

                                    <div className="ml-3">
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Time
                                      </span>
                                      <EventEHRTimePicker
                                        name={"time"}
                                        defaultValue={true}
                                        value={
                                          endotrachealIntubationProperties?.time
                                        }
                                        onChangeCb={(value) => {
                                          setEndotrachealIntubationProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              time: value,
                                            })
                                          );
                                        }}
                                        // isStarPresent={true}
                                        // label="Enter Time of Encounter"
                                        style={{ width: "100%" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {procedureDone?.airwayManagement &&
                              airwayManagement?.iGel && (
                                <div className="pt-5">
                                  <Heading
                                    isRequired
                                    title="iGel Insertion"
                                    customStyle={commonHeadingStyle}
                                  />
                                  <div className="flex gap-5">
                                    <div>
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Size
                                      </span>
                                      <SelectDropdown
                                        // label="Select Type of Care"
                                        value={iGelProperties?.size}
                                        displayEmpty
                                        options={I_GEL_SIZE_OPTION}
                                        onChangeCb={(e, label) => {
                                          setIGelProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              size: e.target.value,
                                            })
                                          );
                                        }}
                                      />
                                    </div>

                                    <div>
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Attempts
                                      </span>
                                      <SelectDropdown
                                        // label="Select Type of Care"
                                        value={iGelProperties?.attempts}
                                        displayEmpty
                                        options={I_GEL_ATTEMPTS_OPTION}
                                        onChangeCb={(e, label) => {
                                          setIGelProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              attempts: e.target.value,
                                            })
                                          );
                                        }}
                                      />
                                    </div>

                                    <div className="ml-3">
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Successful?
                                      </span>
                                      <EventEHRRadioButton
                                        selectedValue={
                                          iGelProperties?.successful
                                        }
                                        name=""
                                        grid
                                        style={iGelGridStyle}
                                        labelCustomStyle={{
                                          marginLeft: "10px",
                                          color: "#565656",
                                        }}
                                        optionList={IS_SUCCESSFUL}
                                        handleOnChange={(value: any) => {
                                          setIGelProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              successful: value,
                                            })
                                          );
                                        }}
                                      />
                                    </div>

                                    <div className="ml-3">
                                      <span
                                        style={commonTriageFieldHeadingStyle}
                                      >
                                        Time
                                      </span>
                                      <EventEHRTimePicker
                                        defaultValue={true}
                                        name={"time"}
                                        value={iGelProperties?.time}
                                        onChangeCb={(value) => {
                                          setIGelProperties(
                                            (prevData: any) => ({
                                              ...prevData,
                                              time: value,
                                            })
                                          );
                                        }}
                                        // isStarPresent={true}
                                        // label="Enter Time of Encounter"
                                        style={{ width: "100%" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            {procedureDone?.iVPlacement && (
                              <div>
                                <FieldArray name="ivInsertionData">
                                  {({ push, remove }) => (
                                    <div className="pt-7">
                                      <Heading
                                        title="IV Insertion"
                                        customStyle={commonHeadingStyle}
                                      />
                                      {values.ivInsertionData.map(
                                        (ivInsertion: any, index: any) => (
                                          <div
                                            key={index}
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <div>
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Size
                                              </span>
                                              <SelectDropdown
                                                name={`ivInsertionData.${index}.size`}
                                                // label="Select Type of Care"
                                                value={ivInsertion?.size}
                                                displayEmpty
                                                options={IV_INSERTION_SIZE}
                                                onChangeCb={(e, label) => {
                                                  setFieldValue(
                                                    `ivInsertionData.${index}.size`,
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div>
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Attempts
                                              </span>

                                              <Input
                                                type="number"
                                                name={`ivInsertionData.${index}.attempts`}
                                                value={ivInsertion.attempts}
                                                onChangeCb={(e) => {
                                                  setFieldValue(
                                                    `ivInsertionData.${index}.attempts`,
                                                    e.target.value
                                                  );
                                                }}
                                                size="small"
                                              />
                                            </div>

                                            <div className="ml-3">
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Successful?
                                              </span>
                                              <EventEHRRadioButton
                                                selectedValue={
                                                  ivInsertion?.successful
                                                }
                                                name={`ivInsertionData.${index}.successful`}
                                                grid
                                                style={iGelGridStyle}
                                                labelCustomStyle={{
                                                  marginLeft: "10px",
                                                  color: "#565656",
                                                }}
                                                optionList={IS_SUCCESSFUL}
                                                handleOnChange={(
                                                  value: any
                                                ) => {
                                                  setFieldValue(
                                                    `ivInsertionData.${index}.successful`,
                                                    value
                                                  );
                                                }}
                                              />
                                            </div>

                                            <div className="ml-3">
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Time
                                              </span>
                                              <EventEHRTimePicker
                                                defaultValue={true}
                                                name={`ivInsertionData.${index}.time`}
                                                value={ivInsertion?.time}
                                                onChangeCb={(value) => {
                                                  setFieldValue(
                                                    `ivInsertionData.${index}.time`,
                                                    value
                                                  );
                                                }}
                                                // isStarPresent={true}
                                                // label="Enter Time of Encounter"
                                                style={{ width: "100%" }}
                                              />
                                            </div>

                                            {/* Remove Button */}
                                            {values?.ivInsertionData?.length >
                                              1 && (
                                              <div className="pt-7 cursor-pointer">
                                                <DeleteIcon
                                                  onClick={() => remove(index)}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        )
                                      )}

                                      {/* Add Vital Button */}
                                      <Button
                                        type="button"
                                        label={"+ Addtl IVs"}
                                        variant="contained"
                                        onClickCb={() =>
                                          push({
                                            size: "",
                                            attempts: "1",
                                            successful: "",
                                            time: "",
                                          })
                                        }
                                      ></Button>
                                    </div>
                                  )}
                                </FieldArray>
                              </div>
                            )}

                            {procedureDone?.oxygen && (
                              <div>
                                <FieldArray name="oxygenAdministeredData">
                                  {({ push, remove }) => (
                                    <div className="pt-7">
                                      <Heading
                                        isRequired
                                        title="Oxygen Administration "
                                        customStyle={commonHeadingStyle}
                                      />
                                      {values.oxygenAdministeredData.map(
                                        (
                                          oxygenAdministered: any,
                                          index: any
                                        ) => (
                                          <div
                                            key={index}
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <div>
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Device
                                              </span>
                                              <SelectDropdown
                                                name={`oxygenAdministeredData.${index}.device`}
                                                // label="Select Type of Care"
                                                value={
                                                  oxygenAdministered?.device
                                                }
                                                displayEmpty
                                                options={DEVICE}
                                                onChangeCb={(e, label) => {
                                                  setFieldValue(
                                                    `oxygenAdministeredData.${index}.device`,
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div>
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                LPM
                                              </span>

                                              <Input
                                                type="number"
                                                name={`oxygenAdministeredData.${index}.lpm`}
                                                value={oxygenAdministered.lpm}
                                                onChangeCb={(e) => {
                                                  setFieldValue(
                                                    `oxygenAdministeredData.${index}.lpm`,
                                                    e.target.value
                                                  );
                                                }}
                                                size="small"
                                              />
                                            </div>

                                            <div className="ml-3">
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Improvement?
                                              </span>
                                              <EventEHRRadioButton
                                                selectedValue={
                                                  oxygenAdministered?.improvement
                                                }
                                                name={`oxygenAdministeredData.${index}.improvement`}
                                                grid
                                                style={iGelGridStyle}
                                                labelCustomStyle={{
                                                  marginLeft: "10px",
                                                  color: "#565656",
                                                }}
                                                optionList={IS_SUCCESSFUL}
                                                handleOnChange={(
                                                  value: any
                                                ) => {
                                                  setFieldValue(
                                                    `oxygenAdministeredData.${index}.improvement`,
                                                    value
                                                  );
                                                }}
                                              />
                                            </div>

                                            <div className="ml-3">
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Time
                                              </span>
                                              <EventEHRTimePicker
                                                defaultValue={true}
                                                name={`oxygenAdministeredData.${index}.time`}
                                                value={oxygenAdministered?.time}
                                                onChangeCb={(value) => {
                                                  setFieldValue(
                                                    `oxygenAdministeredData.${index}.time`,
                                                    value
                                                  );
                                                }}
                                                // isStarPresent={true}
                                                // label="Enter Time of Encounter"
                                                style={{ width: "100%" }}
                                              />
                                            </div>

                                            {/* Remove Button */}
                                            {values?.oxygenAdministeredData
                                              ?.length > 1 && (
                                              <div className="pt-7 cursor-pointer">
                                                <DeleteIcon
                                                  onClick={() => remove(index)}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        )
                                      )}

                                      {/* Add Vital Button */}
                                      <Button
                                        type="button"
                                        label={"+ Addtl IVs"}
                                        variant="contained"
                                        onClickCb={() =>
                                          push({
                                            device: "",
                                            lpm: "",
                                            improvement: "",
                                            time: "",
                                          })
                                        }
                                      ></Button>
                                    </div>
                                  )}
                                </FieldArray>
                              </div>
                            )}

                            {procedureDone?.medicationsAdministered && (
                              <div>
                                <FieldArray name="medicationsAdministeredData">
                                  {({ push, remove }) => (
                                    <div className="pt-7">
                                      <Heading
                                        title="Medications Administered"
                                        customStyle={commonHeadingStyle}
                                        isRequired
                                      />
                                      {values.medicationsAdministeredData.map(
                                        (
                                          medicationsAdministered: any,
                                          index: any
                                        ) => (
                                          <div
                                            key={index}
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <div>
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Medication
                                              </span>
                                              <SelectDropdown
                                                name={`medicationsAdministeredData.${index}.medication`}
                                                // label="Select Type of Care"
                                                value={
                                                  medicationsAdministered?.medication
                                                }
                                                displayEmpty
                                                options={
                                                  MEDICATIONS_ADMINISTERED_LIST
                                                }
                                                onChangeCb={(e, label) => {
                                                  setFieldValue(
                                                    `medicationsAdministeredData.${index}.medication`,
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div>
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Dose (mg)
                                              </span>

                                              <Input
                                                name={`medicationsAdministeredData.${index}.dose`}
                                                value={
                                                  medicationsAdministered.dose
                                                }
                                                type="number"
                                                onChangeCb={(e) => {
                                                  setFieldValue(
                                                    `medicationsAdministeredData.${index}.dose`,
                                                    e.target.value
                                                  );
                                                }}
                                                size="small"
                                              />
                                            </div>

                                            <div className="pl-10 pr-10">
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Route
                                              </span>
                                              <EventEHRRadioButton
                                                selectedValue={
                                                  medicationsAdministered?.route
                                                }
                                                name={`medicationsAdministeredData.${index}.route`}
                                                grid
                                                style={iGelGridStyle}
                                                labelCustomStyle={{
                                                  marginLeft: "10px",
                                                  color: "#565656",
                                                }}
                                                optionList={MA_ROUTE}
                                                handleOnChange={(
                                                  value: any
                                                ) => {
                                                  setFieldValue(
                                                    `medicationsAdministeredData.${index}.route`,
                                                    value
                                                  );
                                                }}
                                              />
                                            </div>

                                            <div className="pr-10">
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Response
                                              </span>
                                              <EventEHRRadioButton
                                                selectedValue={
                                                  medicationsAdministered?.response
                                                }
                                                name={`medicationsAdministeredData.${index}.response`}
                                                grid
                                                style={iGelGridStyle}
                                                labelCustomStyle={{
                                                  marginLeft: "10px",
                                                  color: "#565656",
                                                }}
                                                optionList={MA_RESPONSE}
                                                handleOnChange={(
                                                  value: any
                                                ) => {
                                                  setFieldValue(
                                                    `medicationsAdministeredData.${index}.response`,
                                                    value
                                                  );
                                                }}
                                              />
                                            </div>

                                            <div className="ml-3">
                                              <span
                                                style={
                                                  commonTriageFieldHeadingStyle
                                                }
                                              >
                                                Time
                                              </span>
                                              <EventEHRTimePicker
                                                defaultValue={true}
                                                name={`medicationsAdministeredData.${index}.time`}
                                                value={
                                                  medicationsAdministered?.time
                                                }
                                                onChangeCb={(value) => {
                                                  setFieldValue(
                                                    `medicationsAdministeredData.${index}.time`,
                                                    value
                                                  );
                                                }}
                                                // isStarPresent={true}
                                                // label="Enter Time of Encounter"
                                                style={{ width: "100%" }}
                                              />
                                            </div>

                                            {/* Remove Button */}
                                            {values?.medicationsAdministeredData
                                              ?.length > 1 && (
                                              <div className="pt-7 cursor-pointer">
                                                <DeleteIcon
                                                  onClick={() => remove(index)}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        )
                                      )}

                                      {/* Add Vital Button */}
                                      <Button
                                        type="button"
                                        label={"+ Addtl Meds"}
                                        variant="contained"
                                        onClickCb={() =>
                                          push({
                                            medication: "",
                                            dose: "",
                                            route: "",
                                            response: "",
                                            time: "",
                                          })
                                        }
                                      ></Button>
                                    </div>
                                  )}
                                </FieldArray>
                              </div>
                            )}

                            {procedureDone?.LeadEKG && (
                              <div className="pt-5">
                                <div className="w-[30%]">
                                  <Heading
                                    title="12 Lead Interpretation"
                                    customStyle={commonHeadingStyle}
                                  />
                                  <Input
                                    name={
                                      JOT_FORM_DATA.LEAD_INTERPRETATION_TEXT
                                    }
                                    value={
                                      values[
                                        JOT_FORM_DATA.LEAD_INTERPRETATION_TEXT
                                      ]
                                    }
                                    onChangeCb={(e) => {
                                      setFieldValue(
                                        JOT_FORM_DATA.LEAD_INTERPRETATION_TEXT,
                                        e.target.value
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    size="small"
                                    error={
                                      touched[
                                        JOT_FORM_DATA.LEAD_INTERPRETATION_TEXT
                                      ] &&
                                      Boolean(
                                        errors[
                                          JOT_FORM_DATA.LEAD_INTERPRETATION_TEXT
                                        ]
                                      )
                                    }
                                    helperText={
                                      touched[
                                        JOT_FORM_DATA.LEAD_INTERPRETATION_TEXT
                                      ]
                                        ? errors[
                                            JOT_FORM_DATA
                                              .LEAD_INTERPRETATION_TEXT
                                          ]
                                        : undefined
                                    }
                                  />
                                </div>
                                <div className=" pt-5">
                                  <Heading
                                    title="12 Lead Photo"
                                    customStyle={commonHeadingStyle}
                                  />
                                  <div>
                                    <div className="flex flex-col items-start gap-4">
                                      {/* Buttons */}
                                      {!capturedPhoto && !showCamera && (
                                        <Button
                                          label="Take Photo"
                                          variant="contained"
                                          onClickCb={() => setShowCamera(true)}
                                        />
                                      )}

                                      {capturedPhoto && (
                                        <div className="flex gap-2">
                                          <Button
                                            label="Retake Photo"
                                            variant="contained"
                                            onClickCb={() =>
                                              setShowCamera(true)
                                            }
                                          />

                                          <SimpleButton
                                            variant="contained"
                                            // onClickCb={handleFileUpload}
                                            style={{
                                              background: "#005596",
                                              textTransform: "capitalize",
                                              fontWeight: "500",
                                              fontFamily: "Inter",
                                            }}
                                            component="label"
                                          >
                                            Upload from Gallery
                                            <input
                                              type="file"
                                              accept="image/*"
                                              hidden
                                              onChange={handleFileUpload}
                                            />
                                          </SimpleButton>
                                          <IconButton
                                            color="error"
                                            onClick={handleDeletePhoto}
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                        </div>
                                      )}

                                      {/* Camera */}
                                      {showCamera && (
                                        <div
                                          className="flex flex-col gap-2 items-start"
                                          style={{
                                            position: "absolute",
                                            bottom: "80px",
                                            zIndex: 1000,
                                          }}
                                        >
                                          <CancelRoundedIcon
                                            className="self-end text-[#8a2222] cursor-pointer"
                                            onClick={() => setShowCamera(false)}
                                          />
                                          <Webcam
                                            ref={webcamRef}
                                            screenshotFormat="image/png"
                                            videoConstraints={{
                                              width: 600,
                                              height: 420,
                                              facingMode: "user",
                                            }}
                                          />
                                          <Button
                                            label="Capture"
                                            variant="contained"
                                            onClickCb={capturePhoto}
                                          />
                                        </div>
                                      )}

                                      {/* Display Captured Image */}
                                      {capturedPhoto && (
                                        <div className="mt-4">
                                          <h3>Captured Image:</h3>
                                          <img
                                            src={capturedPhoto}
                                            alt="Captured"
                                            style={{
                                              width: "300px",
                                              height: "auto",
                                              borderRadius: "8px",
                                            }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    {/* IFT SOAP Note */}
                    {unitType === "mf_ito" && (
                      <Accordion sx={accordionBgColor} className="mt-0">
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          IFT SOAP Note
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: "white" }}>
                          <div>
                            <div className="pt-5">
                              <Heading
                                title="Please include a brief SOAP note of your transport, including vital signs, if necessary."
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                multiline={true}
                                rows={5}
                                // textFieldLabel="Enter Chief Complaint"
                                name={JOT_FORM_DATA.IFT_SOAP_NOTE}
                                value={values[JOT_FORM_DATA.IFT_SOAP_NOTE]}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.IFT_SOAP_NOTE,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                size="small"
                                error={
                                  touched[JOT_FORM_DATA.IFT_SOAP_NOTE] &&
                                  Boolean(errors[JOT_FORM_DATA.IFT_SOAP_NOTE])
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.IFT_SOAP_NOTE]
                                    ? errors[JOT_FORM_DATA.IFT_SOAP_NOTE]
                                    : undefined
                                }
                              />
                              <span className="text-[10px] text-[#004981]">
                                Subjective, Objective, Assessment and Plan
                              </span>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    {/*   Diagnosis and Disposition
                     */}
                    <Accordion sx={accordionBgColor}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        Diagnosis and Disposition{" "}
                      </AccordionSummary>
                      <AccordionDetails sx={{ backgroundColor: "white" }}>
                        <div className="p-3">
                          <div className="w-[30%]">
                            <Heading
                              title="Impression/Diagnosis"
                              customStyle={commonHeadingStyle}
                            />
                            <EventEHRLazyDropdown
                              placeholder="Search ICD 10 / DSM Code"
                              startIcon={
                                <img
                                  alt="search-icon"
                                  src={searchIcon}
                                  width={"18px"}
                                  height={"18px"}
                                />
                              }
                              dropdownIcon={true}
                              dropdownOptions={impressionDiagnosisOptions?.filter(
                                (o) => o?.value !== ""
                              )}
                              selectedValue={
                                impressionDiagnosisOptions?.find(
                                  (o) =>
                                    o?.value ===
                                    values[JOT_FORM_DATA.IMPRESSION_DIAGNOSIS]
                                ) ||
                                (values[JOT_FORM_DATA.IMPRESSION_DIAGNOSIS]
                                  ? {
                                      label:
                                        values[
                                          JOT_FORM_DATA.IMPRESSION_DIAGNOSIS
                                        ],
                                      value:
                                        values[
                                          JOT_FORM_DATA.IMPRESSION_DIAGNOSIS
                                        ],
                                    }
                                  : null)
                              }
                              dropdownSearch={impressionSearch}
                              setDropdownSearch={handleImpressionSearchChange}
                              setPageCount={(data) =>
                                setImpressionPageCount(data)
                              }
                              setResetFlag={(flag) => {
                                if (flag) {
                                  setImpressionPageCount(1);
                                  setImpressionSearch("");
                                  setFieldValue(
                                    JOT_FORM_DATA.IMPRESSION_DIAGNOSIS,
                                    ""
                                  );
                                }
                              }}
                              setSelectedValue={(data) =>
                                setFieldValue(
                                  JOT_FORM_DATA.IMPRESSION_DIAGNOSIS,
                                  data?.value || ""
                                )
                              }
                              noOptionText={
                                (impressionSearch?.trim()?.length || 0) > 0 &&
                                (impressionSearch?.trim()?.length || 0) < 3
                                  ? "Type at least 3 characters to search"
                                  : (impressionDiagnosisOptions?.length || 0) ===
                                      0
                                    ? "Loading..."
                                    : "No options found"
                              }
                              // Results come pre-filtered from the server
                              // (diagnosisName ORs code + name + description),
                              // so don't re-filter client-side.
                              filterOptions={(options) => options}
                              onBlur={handleBlur}
                              error={
                                touched[JOT_FORM_DATA.IMPRESSION_DIAGNOSIS] &&
                                Boolean(
                                  errors[JOT_FORM_DATA.IMPRESSION_DIAGNOSIS]
                                )
                              }
                              helperText={
                                touched[JOT_FORM_DATA.IMPRESSION_DIAGNOSIS]
                                  ? errors[JOT_FORM_DATA.IMPRESSION_DIAGNOSIS]
                                  : undefined
                              }
                            />
                          </div>

                          <div className="ml-2 mr-2 mt-8 mb-4">
                            <Heading
                              title="Disposition"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <EventEHRRadioButton
                              selectedValue={disposition}
                              grid={true}
                              style={iGelGridStyle}
                              name=""
                              labelCustomStyle={{
                                marginLeft: "10px",
                                color: "#565656",
                              }}
                              optionList={DISPOSITION_LIST}
                              handleOnChange={(value: any) => {
                                setFieldValue(
                                  JOT_FORM_DATA.DISPOSITION_TYPE,
                                  ""
                                );
                                // Reset Type of Care whenever the disposition
                                // changes (only relevant for treat-and-transport).
                                setFieldValue(JOT_FORM_DATA.TYPE_OF_CARE, "");
                                setFieldValue(
                                  JOT_FORM_DATA.TYPE_OF_CARE_NAME,
                                  ""
                                );
                                if (value === "treated_and_transported") {
                                  const payload = {
                                    pageNumber: 1,
                                    limit: 30,
                                    // name: searchedValue?.trim(),
                                    // status: status ? status : "",
                                  };
                                  dispatch(getFacilityList(payload));
                                }
                                setDisposition(value);
                                setFieldValue(
                                  JOT_FORM_DATA.DISPOSITION_TYPE,
                                  value
                                );
                              }}
                            />
                          </div>

                          {disposition === "treated_and_transported" && (
                            <div className="w-[30%] mb-4">
                              <Heading
                                isRequired
                                title="Transport Destination"
                                customStyle={commonHeadingStyle}
                              />
                              <SelectDropdown
                                displayEmpty
                                name={JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE}
                                value={
                                  values[
                                    JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE
                                  ]
                                }
                                options={transportDestinationList}
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE,
                                    e.target.value
                                  );
                                  // Reset dependent Type of Care when the
                                  // destination facility changes.
                                  setFieldValue(JOT_FORM_DATA.TYPE_OF_CARE, "");
                                  setFieldValue(
                                    JOT_FORM_DATA.TYPE_OF_CARE_NAME,
                                    ""
                                  );
                                }}
                                onBlur={handleBlur}
                                error={
                                  touched[
                                    JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE
                                  ] &&
                                  Boolean(
                                    errors[
                                      JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE
                                    ]
                                  )
                                }
                                helperText={
                                  touched[
                                    JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE
                                  ]
                                    ? errors[
                                        JOT_FORM_DATA.TRANSPORT_DESTINATION_TYPE
                                      ]
                                    : undefined
                                }
                              />
                            </div>
                          )}

                          {disposition === "treated_and_transported" && (
                            <div className="w-[30%] mb-4">
                              <Heading
                                isRequired
                                title="Type of Care"
                                customStyle={commonHeadingStyle}
                              />
                              <SelectDropdown
                                displayEmpty
                                name={JOT_FORM_DATA.TYPE_OF_CARE}
                                value={values[JOT_FORM_DATA.TYPE_OF_CARE]}
                                options={typeOfCareList}
                                onChangeCb={(e, label) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.TYPE_OF_CARE,
                                    e.target.value
                                  );
                                  setFieldValue(
                                    JOT_FORM_DATA.TYPE_OF_CARE_NAME,
                                    label !== "Self Care" ? label : "Self_Care"
                                  );
                                }}
                                onBlur={handleBlur}
                                error={
                                  touched[JOT_FORM_DATA.TYPE_OF_CARE] &&
                                  Boolean(errors[JOT_FORM_DATA.TYPE_OF_CARE])
                                }
                                helperText={
                                  touched[JOT_FORM_DATA.TYPE_OF_CARE]
                                    ? errors[JOT_FORM_DATA.TYPE_OF_CARE]
                                    : undefined
                                }
                              />
                            </div>
                          )}

                          {disposition !== "sent_hospital_ems" &&
                            disposition !== "sent_hospital_air" &&
                            disposition !== "sent_hospital_pov" &&
                            disposition !== "sent_hospital_nsj" && (
                              <div className="w-[30%]">
                                <Heading
                                  title="Transferring Unit"
                                  customStyle={commonHeadingStyle}
                                />
                                <SelectDropdown
                                  displayEmpty
                                  placeholderValue="Please Select"
                                  name={JOT_FORM_DATA.TRANSFERRING_UNIT}
                                  value={
                                    values[JOT_FORM_DATA.TRANSFERRING_UNIT]
                                  }
                                  options={unitDesignationOptions}
                                  onChangeCb={(e) => {
                                    setFieldValue(
                                      JOT_FORM_DATA.TRANSFERRING_UNIT,
                                      e.target.value
                                    );
                                  }}
                                  onBlur={handleBlur}
                                  error={
                                    touched[JOT_FORM_DATA.TRANSFERRING_UNIT] &&
                                    Boolean(
                                      errors[JOT_FORM_DATA.TRANSFERRING_UNIT]
                                    )
                                  }
                                  helperText={
                                    touched[JOT_FORM_DATA.TRANSFERRING_UNIT]
                                      ? errors[JOT_FORM_DATA.TRANSFERRING_UNIT]
                                      : undefined
                                  }
                                />
                              </div>
                            )}
                        </div>
                      </AccordionDetails>
                    </Accordion>

                    {/* Treat and Release */}
                    {disposition === "treated_and_released" && (
                      <Accordion sx={accordionBgColor}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          Treat and Release
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: "white" }}>
                          <div className="p-3 text-[#004981]">
                            <h3 className="text-[16px]">
                              I, the treating EMS Clinician, certify that this
                              individual is greater that 18 years of age, or in
                              the care of someone 18 years of age or older. If
                              more than scout rendered first aid was provided
                              AND the patient is a minor with no adult is
                              present, the scout must be taken to a medical
                              facility to be evaluated and released by a
                              physician.
                            </h3>
                            <div className="pt-3">
                              <EventEHRRadioButton
                                selectedValue={
                                  values[
                                    JOT_FORM_DATA.TREAT_AND_RELEASE_CHECKED
                                  ]
                                }
                                grid={true}
                                style={iGelGridStyle}
                                name=""
                                labelCustomStyle={{
                                  marginLeft: "10px",
                                  color: "#565656",
                                }}
                                optionList={[
                                  {
                                    label:
                                      "By clicking this box, I agree to the above statement.",
                                    value: treatAndReleaseChecked.isSelected,
                                  },
                                ]}
                                handleOnChange={(value: any) => {
                                  setTreatAndReleaseChecked((prev) => ({
                                    ...prev,
                                    isSelected:
                                      !treatAndReleaseChecked.isSelected,
                                  }));
                                  setFieldValue(
                                    JOT_FORM_DATA.TREAT_AND_RELEASE_CHECKED,
                                    !value
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="pt-5 pb-5">
                            <hr />
                          </div>

                          {treatAndReleaseChecked?.isSelected && (
                            <div className="p-3 text-[#004981]">
                              <h3 className="text-[16px]">
                                Neither I nor the attending EMT(s) and/or
                                paramedic(s) believe that I, my child, or the
                                scout I am supervising have an illness or injury
                                requiring EMS transport to a Jamboree Medical
                                Facility. I agree the the provided care is
                                sufficient for the injury, as we understand it
                                at this time. I agree that the patient does not
                                need further EMS assessment, treatment or
                                transportation at this time. I understand that
                                if I change my mind or if my condition changes
                                and I wish further treatment / transportation by
                                the Emergency Medical Services (EMS) system; I
                                can call the SOC for assistance or present at
                                any Jamboree Medical Facility.Neither I nor the
                                attending EMT(s) and/or paramedic(s) believe
                                that I, my child, or the scout I am supervising
                                have an illness or injury requiring EMS
                                transport to a Jamboree Medical Facility. I
                                agree the the provided care is sufficient for
                                the injury, as we understand it at this time. I
                                agree that the patient does not need further EMS
                                assessment, treatment or transportation at this
                                time. I understand that if I change my mind or
                                if my condition changes and I wish further
                                treatment / transportation by the Emergency
                                Medical Services (EMS) system; I can call the
                                SOC for assistance or present at any Jamboree
                                Medical Facility.
                              </h3>
                              <div className="w-[30%] pt-3">
                                <Input
                                  name={
                                    JOT_FORM_DATA.TREAT_AND_RELEASE_USER_NAME
                                  }
                                  value={
                                    values[
                                      JOT_FORM_DATA.TREAT_AND_RELEASE_USER_NAME
                                    ]
                                  }
                                  onChangeCb={(e) => {
                                    setFieldValue(
                                      JOT_FORM_DATA.TREAT_AND_RELEASE_USER_NAME,
                                      e.target.value
                                    );
                                  }}
                                  onBlur={handleBlur}
                                  size="small"
                                  error={
                                    touched[
                                      JOT_FORM_DATA.TREAT_AND_RELEASE_USER_NAME
                                    ] &&
                                    Boolean(
                                      errors[
                                        JOT_FORM_DATA
                                          .TREAT_AND_RELEASE_USER_NAME
                                      ]
                                    )
                                  }
                                  helperText={
                                    touched[
                                      JOT_FORM_DATA.TREAT_AND_RELEASE_USER_NAME
                                    ]
                                      ? errors[
                                          JOT_FORM_DATA
                                            .TREAT_AND_RELEASE_USER_NAME
                                        ]
                                      : undefined
                                  }
                                />
                                <span className="text-[10px] text-[#004981]">
                                  Type your name here.{" "}
                                </span>
                              </div>
                              <div className="w-[30%] pt-7">
                                <Heading
                                  title="Treat and Release Signature"
                                  customStyle={commonHeadingStyle}
                                />
                                <div className="pt-3 pb-4 pr-4">
                                  <div
                                    style={{
                                      display: "flex, border:'1px solid red",
                                      background: "#F4F4F4",
                                      padding: "10px 20px",
                                    }}
                                    className="text-center border-radius-8px"
                                  >
                                    <div
                                      style={{
                                        fontSize: "32px",
                                        fontFamily: "Sacramento",
                                      }}
                                    >
                                      {
                                        values[
                                          JOT_FORM_DATA
                                            .TREAT_AND_RELEASE_USER_NAME
                                        ]
                                      }
                                    </div>
                                    <div className="font-weight-500 font-size-12px color-565656 ">
                                      Signature
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Refusal of Medical Aid/Transport */}
                    {disposition === "refusal_medical_aid_transport" && (
                      <Accordion sx={accordionBgColor}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          Refusal of Medical Aid/Transport
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: "white" }}>
                          <div className="p-3 text-[#004981]">
                            <h3 className="text-[16px]">
                              I hereby acknowledge and release the
                              above-mentioned emergency service provider and its
                              personnel, Summit Bechtel Reserve, the BSA, and
                              all EMS system physicians, nurses, agents and
                              personnel of any liability for my refusal to
                              accept further treatment. I acknowledge that I
                              have been advised of and understand the risks of
                              not accepting emergency treatment and/or
                              transportation to the nearest hospital facility,
                              which I am refusing. I have been advised as
                              follows: - That I should receive emergency medical
                              treatment and transportation to a hospital, which
                              I am refusing. - That having received emergency
                              medical treatment, I am refusing further aid or
                              transport to a medical facility. - I am refusing
                              all medical assessment, treatment and transport. -
                              That my failure to seek treatment and transport
                              could result in permanent injury, impairment,
                              disability and could lead to my death. - I certify
                              that I have the ability and appreciate the
                              consequences of making decisions regarding my
                              medical treatment and the ability to reach an
                              informed decision. - I have been made aware and
                              understand that I can call Emergency Medical
                              Services again at any time and/or seek out medical
                              care at a Jamboree Medical Facility or other
                              community medical facility in the area.
                            </h3>
                            <div className="w-[30%] pt-3">
                              <Input
                                name={JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_NAME}
                                value={
                                  values[
                                    JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_NAME
                                  ]
                                }
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_NAME,
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                size="small"
                                error={
                                  touched[
                                    JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_NAME
                                  ] &&
                                  Boolean(
                                    errors[
                                      JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_NAME
                                    ]
                                  )
                                }
                                helperText={
                                  touched[
                                    JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_NAME
                                  ]
                                    ? errors[
                                        JOT_FORM_DATA
                                          .REFUSAL_OF_MEDICAL_AID_NAME
                                      ]
                                    : undefined
                                }
                              />
                              <span className="text-[10px] text-[#004981]">
                                Type your name if you agree and sign below
                              </span>
                            </div>
                            <div className="w-[30%] pt-7">
                              <Heading
                                title="RMA Release:"
                                customStyle={commonHeadingStyle}
                              />
                              <div className="pt-3 pb-4 pr-4">
                                <div
                                  style={{
                                    display: "flex, border:'1px solid red",
                                    background: "#F4F4F4",
                                    padding: "10px 20px",
                                  }}
                                  className="text-center border-radius-8px"
                                >
                                  <div
                                    style={{
                                      fontSize: "32px",
                                      fontFamily: "Sacramento",
                                    }}
                                  >
                                    {
                                      values[
                                        JOT_FORM_DATA
                                          .REFUSAL_OF_MEDICAL_AID_NAME
                                      ]
                                    }
                                  </div>
                                  <div className="font-weight-500 font-size-12px color-565656 ">
                                    Signature
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div>
                            <div className="w-[60%] pt-7">
                              <Heading
                                title="Witness Name"
                                customStyle={commonHeadingStyle}
                              />
                              <Input
                                maxLength={100}
                                name={
                                  JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_WITNESS_NAME
                                }
                                value={
                                  values[
                                    JOT_FORM_DATA
                                      .REFUSAL_OF_MEDICAL_AID_WITNESS_NAME
                                  ]
                                }
                                onChangeCb={(e) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.REFUSAL_OF_MEDICAL_AID_WITNESS_NAME,
                                    e.target.value
                                  );
                                }}
                                size="small"
                                onBlur={handleBlur}
                                error={
                                  touched[
                                    JOT_FORM_DATA
                                      .REFUSAL_OF_MEDICAL_AID_WITNESS_NAME
                                  ] &&
                                  Boolean(
                                    errors[
                                      JOT_FORM_DATA
                                        .REFUSAL_OF_MEDICAL_AID_WITNESS_NAME
                                    ]
                                  )
                                }
                                helperText={
                                  touched[
                                    JOT_FORM_DATA
                                      .REFUSAL_OF_MEDICAL_AID_WITNESS_NAME
                                  ]
                                    ? errors[
                                        JOT_FORM_DATA
                                          .REFUSAL_OF_MEDICAL_AID_WITNESS_NAME
                                      ]
                                    : undefined
                                }
                              />
                            </div>

                            <div className="w-[30%] pt-7">
                              <Heading
                                title="Witness Signature"
                                customStyle={commonHeadingStyle}
                              />
                              <div className="pt-3 pb-4 pr-4">
                                <div
                                  style={{
                                    display: "flex, border:'1px solid red",
                                    background: "#F4F4F4",
                                    padding: "10px 20px",
                                  }}
                                  className="text-center border-radius-8px"
                                >
                                  <div
                                    style={{
                                      fontSize: "32px",
                                      fontFamily: "Sacramento",
                                    }}
                                  >
                                    {
                                      values[
                                        JOT_FORM_DATA
                                          .REFUSAL_OF_MEDICAL_AID_WITNESS_NAME
                                      ]
                                    }
                                  </div>
                                  <div className="font-weight-500 font-size-12px color-565656 ">
                                    Signature
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    {/* Off Site Transfer */}
                    {(disposition === "sent_hospital_ems" ||
                      disposition === "sent_hospital_air" ||
                      disposition === "sent_hospital_pov" ||
                      disposition === "sent_hospital_nsj") && (
                      <Accordion sx={accordionBgColor}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          Off Site Transfer{" "}
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: "white" }}>
                          <div className="w-[30%] pt-3">
                            <Heading
                              title="Hospital/Off Site Facility"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <SelectDropdown
                              // label="Please Select"
                              displayEmpty
                              name={JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY}
                              value={
                                values[JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY]
                              }
                              options={hospitalOffSiteFacilityOptions}
                              onChangeCb={(e) => {
                                setFieldValue(
                                  JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY,
                                  e.target.value
                                );
                              }}
                              onBlur={handleBlur}
                              error={
                                touched[
                                  JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY
                                ] &&
                                Boolean(
                                  errors[
                                    JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY
                                  ]
                                )
                              }
                              helperText={
                                touched[
                                  JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY
                                ]
                                  ? errors[
                                      JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY
                                    ]
                                  : undefined
                              }
                            />
                          </div>
                          <div className="w-[30%] pt-5">
                            <Heading
                              title="Transferring Unit"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <SelectDropdown
                              // label="Please Select"
                              displayEmpty
                              placeholderValue="Please Select"
                              name={
                                JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT
                              }
                              value={
                                values[
                                  JOT_FORM_DATA
                                    .HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT
                                ]
                              }
                              options={unitDesignationOptions}
                              onChangeCb={(e) => {
                                setFieldValue(
                                  JOT_FORM_DATA.HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT,
                                  e.target.value
                                );
                              }}
                              onBlur={handleBlur}
                              error={
                                touched[
                                  JOT_FORM_DATA
                                    .HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT
                                ] &&
                                Boolean(
                                  errors[
                                    JOT_FORM_DATA
                                      .HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT
                                  ]
                                )
                              }
                              helperText={
                                touched[
                                  JOT_FORM_DATA
                                    .HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT
                                ]
                                  ? errors[
                                      JOT_FORM_DATA
                                        .HOSPITAL_OFF_SITE_FACILITY_TRANSFERRING_UNIT
                                    ]
                                  : undefined
                              }
                            />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    {/* Signature */}
                    <Accordion sx={accordionBgColor} className="mt-0">
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        Signature
                      </AccordionSummary>
                      <AccordionDetails sx={{ backgroundColor: "white" }}>
                        <div>
                          <div className="w-[30%]">
                            <Heading
                              title="Time Call End"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <EventEHRTimePicker
                              defaultValue={true}
                              name={JOT_FORM_DATA.FINAL_SIGNATURE_TIME}
                              value={values[JOT_FORM_DATA.FINAL_SIGNATURE_TIME]}
                              onChangeCb={(value) => {
                                setFieldValue(
                                  JOT_FORM_DATA.FINAL_SIGNATURE_TIME,
                                  value
                                );
                              }}
                              // isStarPresent={true}
                              // label="Enter Time of "
                              style={{ width: "100%" }}
                              onBlur={handleBlur}
                              error={
                                touched[JOT_FORM_DATA.FINAL_SIGNATURE_TIME] &&
                                Boolean(
                                  errors[JOT_FORM_DATA.FINAL_SIGNATURE_TIME]
                                )
                              }
                              helperText={
                                touched[JOT_FORM_DATA.FINAL_SIGNATURE_TIME]
                                  ? errors[JOT_FORM_DATA.FINAL_SIGNATURE_TIME]
                                  : undefined
                              }
                              // ampmFormat={true} // For 12hr time format
                            />
                          </div>

                          <div className="mt-8">
                            <Heading
                              title="Primary Treating Clinician"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <div className="w-[30%]">
                              <SelectDropdown
                                // label="Select Unit Designation"
                                value={
                                  values[
                                    JOT_FORM_DATA
                                      .FINAL_PRIMARY_TREATING_CLINICIAN
                                  ]
                                }
                                displayEmpty
                                placeholderValue="Please Select"
                                options={primaryTreatingClinicianOptions}
                                onChangeCb={(e, label) => {
                                  setFieldValue(
                                    JOT_FORM_DATA.FINAL_PRIMARY_TREATING_CLINICIAN,
                                    e.target.value
                                  );
                                }}
                                error={
                                  touched[
                                    JOT_FORM_DATA
                                      .FINAL_PRIMARY_TREATING_CLINICIAN
                                  ] &&
                                  Boolean(
                                    errors[
                                      JOT_FORM_DATA
                                        .FINAL_PRIMARY_TREATING_CLINICIAN
                                    ]
                                  )
                                }
                                helperText={
                                  touched[
                                    JOT_FORM_DATA
                                      .FINAL_PRIMARY_TREATING_CLINICIAN
                                  ]
                                    ? errors[
                                        JOT_FORM_DATA
                                          .FINAL_PRIMARY_TREATING_CLINICIAN
                                      ]
                                    : undefined
                                }
                              />
                            </div>
                          </div>

                          <div className="w-[30%] pt-5">
                            <Heading
                              title="Enter Name"
                              isRequired
                              customStyle={commonHeadingStyle}
                            />
                            <Input
                              name={JOT_FORM_DATA.FINAL_SIGNATURE_NAME}
                              value={values[JOT_FORM_DATA.FINAL_SIGNATURE_NAME]}
                              onChangeCb={(e) => {
                                setFieldValue(
                                  JOT_FORM_DATA.FINAL_SIGNATURE_NAME,
                                  e.target.value
                                );
                              }}
                              onBlur={handleBlur}
                              size="small"
                              error={
                                touched[JOT_FORM_DATA.FINAL_SIGNATURE_NAME] &&
                                Boolean(
                                  errors[JOT_FORM_DATA.FINAL_SIGNATURE_NAME]
                                )
                              }
                              helperText={
                                touched[JOT_FORM_DATA.FINAL_SIGNATURE_NAME]
                                  ? errors[JOT_FORM_DATA.FINAL_SIGNATURE_NAME]
                                  : undefined
                              }
                            />
                          </div>
                          <div className="w-[30%] pt-7">
                            <Heading
                              title="Signature"
                              customStyle={commonHeadingStyle}
                            />
                            <div className="pt-3 pb-4 pr-4">
                              <div
                                style={{
                                  display: "flex, border:'1px solid red",
                                  background: "#F4F4F4",
                                  padding: "10px 20px",
                                }}
                                className="text-center border-radius-8px"
                              >
                                <div
                                  style={{
                                    fontSize: "32px",
                                    fontFamily: "Sacramento",
                                  }}
                                >
                                  {values[JOT_FORM_DATA.FINAL_SIGNATURE_NAME]}
                                </div>
                                <div className="font-weight-500 font-size-12px color-565656 ">
                                  Signature
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="pt-3 pb-5">
                            <hr />
                          </div>
                          <div className="flex justify-center items-center gap-2">
                            <Button
                              label="Cancel"
                              onClickCb={() => {
                                navigate("/patient");
                              }}
                              variant={"outlined"}
                            />
                            {/* <Button
                              label="Save As Draft"
                              onClickCb={() => {}}
                              variant={"outlined"}
                              style={{ backgroundColor: "white" }}
                            /> */}
                            <Button
                              type="submit"
                              label="Continue"
                              onClickCb={() => {}}
                              variant={"contained"}
                            />
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>
            </WrapperCard>
          </Form>
        );
      }}
    </Formik>
  );
};

export default JotForm;
